<template>
    <div class="container">
        <!-- <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top> -->
        <div class="">
            <div class="page-content">
                <div style="display: flex;">
                    <div class="phone-view">
                        <div class="phone-scroll" :style="{ backgroundColor: bgColor }" ref="refScroll" id="refScroll"
                            @scroll="scrollContent">
                            <div v-for="(item, index) in viewData" :ref="'refScroll' + index" :id="'refScroll' + index">
                                <!-- 搜索模块 -->
                                <div class="pr mg-bttom"
                                    :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                                    @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                                    @click="handleView(index)" v-if="item.modelType == 1">
                                    <div class="phone-search">
                                        <div class="search-left">
                                            <img src="@/assets/icon_search_36red@2x.png" class="search-icon" alt="" />
                                            <p>请输入搜索内容</p>
                                        </div>
                                        <div class="search-btn">{{ item.modelDetail.navName || '搜索' }}</div>
                                    </div>
                                    <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown"
                                        @toUp="toUp" @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
                                </div>
                                <!-- 轮播图模块 -->
                                <div class="pr mg-bttom"
                                    :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                                    @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                                    @click="handleView(index)" v-if="item.modelType == 2">
                                    <div class="swiper-box"
                                        :style="{ height: item.radioHeight == '2' && item.height ? (item.height / 2 - 32) + 'px' : '124px' }">
                                        <el-carousel indicator-position="none" arrow="never"
                                            :height="item.radioHeight == '2' && item.height ? (item.height / 2 - 32) + 'px' : '124px'">
                                            <el-carousel-item v-for="(sItem, sIndex) in item.modelDetail
                                                .swiperImageList" :key="sIndex">
                                                <img v-if="sItem.imgUrl" :src="sItem.imgUrl" class="swiper-img" alt="" />
                                            </el-carousel-item>
                                        </el-carousel>
                                    </div>
                                    <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown"
                                        @toUp="toUp" @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
                                </div>
                                <!-- 分类导航模块 -->
                                <div class="pr" :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '' }"
                                    @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                                    @click="handleView(index)" v-if="item.modelType == 3">
                                    <div class="two-num" :style="{
                                        'justify-content':
                                            item.modelDetail.categoryNavList.length == 2
                                                ? 'space-around'
                                                : '',
                                    }">
                                        <div class="two-num-item" :style="{
                                            flex:
                                                item.modelDetail.categoryNavList.length == 2
                                                    ? 'flex'
                                                    : '',
                                            width:
                                                item.modelDetail.categoryNavList.length >= 5
                                                    ? '20%'
                                                    : '',
                                        }" v-for="(itemx, indexx) in item.modelDetail.categoryNavList" :key="indexx">
                                            <img :src="itemx.imgUrl ||
                                                require('@/assets/img_pic3@2x.png')
                                                " alt="" class="nav-img" />
                                            <p>
                                                {{
                                                    itemx.categoryNavName
                                                    ? itemx.categoryNavName
                                                    : "分类导航" + (indexx + 1)
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                    <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown"
                                        @toUp="toUp" @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
                                </div>
                                <!-- 图片导航模块 -->
                                <div class="pr mg-bttom"
                                    :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                                    @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                                    @click="handleView(index)" v-if="item.modelType == 4">
                                    <div class="active-box">
                                        <div class="one-img">
                                            <img :src="itemx.imgUrl ||
                                                require('@/assets/img_pic2@2x.png')
                                                " alt="" class="active-img"
                                                v-for="(itemx, indexx) in item.modelDetail.imgList" :key="indexx" />
                                        </div>
                                    </div>
                                    <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown"
                                        @toUp="toUp" @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
                                </div>
                                <!-- 标题模块 -->
                                <div class="pr mg-bttom"
                                    :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                                    @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                                    @click="handleView(index)" v-if="item.modelType == 5">
                                    <div class="title-box" :style="{
                                        'justify-content':
                                            item.modelDetail.showType == 2 ? 'center' : '',
                                    }">
                                        <div class="main-title">
                                            {{ item.modelDetail.mainTitle || "主标题" }}
                                        </div>
                                        <div class="secondary-title">
                                            {{ item.modelDetail.subTitle || "" }}
                                        </div>
                                    </div>
                                    <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown"
                                        @toUp="toUp" @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
                                </div>
                                <!-- 秒杀导航模块 -->
                                <div class="pr mg-bttom"
                                    :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                                    @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                                    @click="handleView(index)" v-if="item.modelType == 6">
                                    <div class="active-box">
                                        <template v-for="itemx in item.modelDetail.activityNavList">
                                            <!-- 一栏 -->
                                            <div class="one-img" style="margin-bottom: 10px" v-if="itemx.showType == 5">
                                                <img :src="require('@/assets/act_box_bg.png')" alt="" class="active-img"
                                                    style="height: auto" />
                                                <div class="act-info">
                                                    <div class="act-name">{{ itemx.navModel.activeName }}</div>
                                                    <div class="act-intro">{{ itemx.navModel.activeSubName }}</div>
                                                </div>
                                            </div>
                                            <!-- 两栏 -->
                                            <div class="two-img" style="margin-bottom: 10px" v-if="itemx.showType == 2">
                                                <div class="two-img-box" style="margin-right: 5px;height: auto;">
                                                    <img :src="itemx.imgUrl ||
                                                        require('@/assets/img_pic2@2x.png')
                                                        " alt="" class="active-img" style="height: 84px;" />
                                                    <p style="text-align: center;font-size: 12px;">{{
                                                        itemx.navModel.activeName
                                                    }}</p>
                                                </div>
                                                <div class="two-img-box" style="height: auto;">
                                                    <img :src="itemx.children[0].imgUrl ||
                                                            require('@/assets/img_pic2@2x.png')
                                                            " alt="" class="active-img" style="height: 84px;" />
                                                    <p style="text-align: center;font-size: 12px;">{{
                                                        itemx.children[0].navModel.activeName }}</p>
                                                </div>
                                            </div>
                                            <!-- 三栏 -->
                                            <div style="margin-bottom: 10px;display: flex;justify-content: space-between;"
                                                v-if="itemx.showType == 3">
                                                <img :src="itemx.imgUrl || require('@/assets/img_pic2@2x.png')"
                                                    style="width: 203px;height: 275px;" alt="">
                                                <div
                                                    style="height: 275px;display: flex;flex-direction: column;justify-content: space-between;">
                                                    <img :src="itemx.children[0].imgUrl || require('@/assets/img_pic2@2x.png')"
                                                        style="width: 137px;height: 141px;" alt="">
                                                    <img :src="itemx.children[1].imgUrl || require('@/assets/img_pic2@2x.png')"
                                                        style="width: 137px;height: 126px;" alt="">
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                    <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown"
                                        @toUp="toUp" @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
                                </div>
                                <!-- 商品模块 -->
                                <div class="pr mg-bttom"
                                    :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                                    @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                                    @click="handleView(index)" v-if="item.modelType == 7">
                                    <div
                                        style="width: 100%;display: flex;align-items: center;justify-content: space-between;padding: 12px 18px;box-sizing: border-box;">
                                        <div style="display: flex;align-items: center;font-size: 12px;color: #F63C56;">
                                            综合
                                            <img style="width: 12px;height: 12px;"
                                                src="@/assets/indexIcon/icon_next_24_2pxred.png" alt="">
                                        </div>
                                        <div style="display: flex;align-items: center;font-size: 12px;color: #333333;">
                                            销量
                                            <img style="width: 12px;height: 12px;margin-left: 4px;"
                                                src="@/assets/indexIcon/icon_next_24black.png" alt="">
                                        </div>
                                        <div style="display: flex;align-items: center;font-size: 12px;color: #333333;">
                                            价格
                                            <img style="width: 12px;height: 12px;margin-left: 4px;"
                                                src="@/assets/indexIcon/icon_next_24black.png" alt="">
                                        </div>
                                    </div>
                                    <div style="width: 100%;overflow-y:auto;white-space:nowrap;margin-bottom:10px;"
                                        v-if="item.modelDetail.goodsType == 2">
                                        <div style="padding:4px 15px;border-radius:14px;background-color:#FEF4F5;border:1px solid #F63C56;color:#F63C56;font-size:12px;margin-right:16px;display:inline-block;"
                                            v-if="item.modelDetail.tagList.length > 0">{{ item.modelDetail.tagList[0].name
                                            }}
                                        </div>
                                        <div style="padding:4px 15px;border-radius:14px;background-color:#F5F5F5;font-size:12px;margin-right:16px;display:inline-block;"
                                            v-for="(itemx, indexx) in item.modelDetail.tagList" :key="indexx"
                                            v-if="indexx > 0">
                                            {{ itemx.name }}
                                        </div>
                                    </div>
                                    <div class="phone-goods" v-if="item.modelDetail.goodsType == 1">
                                        <div class="phone-goods-item" v-for="itemx in item.modelDetail.viewGoodsList">
                                            <img :src="itemx.imgUrl || itemx.mainImage" alt="" class="phone-goods-img" />
                                            <div class="phone-goods-title">
                                                <div v-if="itemx.resultType == 2" class="gift-tips">礼包</div>
                                                {{ itemx.name }}
                                            </div>
                                            <div class="phone-goods-price">
                                                <p class="retail-price">
                                                    <span style="font-size: 10px">￥</span>{{ itemx.price }}
                                                </p>
                                                <p class="market-price">已售{{ itemx.saleNum }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="phone-goods" v-else>
                                        <div class="phone-goods-item" v-for="itemx in item.modelDetail.tagGoodsList">
                                            <img :src="itemx.imgUrl || itemx.headImg" alt="" class="phone-goods-img" />
                                            <div class="phone-goods-title">
                                                <div v-if="itemx.resultType == 2" class="gift-tips">礼包</div>{{ itemx.name }}
                                            </div>
                                            <div class="phone-goods-price">
                                                <p class="retail-price">
                                                    <span style="font-size: 10px">￥</span>{{ itemx.price }}
                                                </p>
                                                <p class="market-price">已售{{ itemx.saleNum }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown"
                                        @toUp="toUp" @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
                                </div>
                                <!-- 活动导航模块 -->
                                <div class="pr mg-bttom"
                                    :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                                    @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                                    @click="handleView(index)" v-if="item.modelType == 8">
                                    <div class="active-box">
                                        <template v-for="itemx in item.modelDetail.activityNavList">
                                            <!-- 一栏 -->
                                            <div class="one-img" style="margin-bottom: 10px" v-if="itemx.showType == 5">
                                                <img :src="itemx.imgUrl ||
                                                    require('@/assets/img_pic2@2x.png')
                                                    " alt="" class="active-img" style="height: auto" />
                                                <p style="text-align: center;font-size: 12px;">{{ itemx.navModel.activeName
                                                }}
                                                </p>
                                            </div>
                                            <!-- 两栏 -->
                                            <div class="two-img" style="margin-bottom: 10px" v-if="itemx.showType == 2">
                                                <div class="two-img-box" style="margin-right: 5px;height: auto;">
                                                    <img :src="itemx.imgUrl ||
                                                        require('@/assets/img_pic2@2x.png')
                                                        " alt="" class="active-img" style="height: 84px;" />
                                                    <p style="text-align: center;font-size: 12px;">{{
                                                        itemx.navModel.activeName
                                                    }}</p>
                                                </div>
                                                <div class="two-img-box" style="height: auto;">
                                                    <img :src="itemx.children[0].imgUrl ||
                                                            require('@/assets/img_pic2@2x.png')
                                                            " alt="" class="active-img" style="height: 84px;" />
                                                    <p style="text-align: center;font-size: 12px;">{{
                                                        itemx.children[0].navModel.activeName }}</p>
                                                </div>
                                            </div>
                                            <!-- 三栏 -->
                                            <div style="margin-bottom: 10px;display: flex;justify-content: space-between;"
                                                v-if="itemx.showType == 3">
                                                <img :src="itemx.imgUrl || require('@/assets/img_pic2@2x.png')"
                                                    style="width: 203px;height: 275px;" alt="">
                                                <div
                                                    style="height: 275px;display: flex;flex-direction: column;justify-content: space-between;">
                                                    <img :src="itemx.children[0].imgUrl || require('@/assets/img_pic2@2x.png')"
                                                        style="width: 137px;height: 141px;" alt="">
                                                    <img :src="itemx.children[1].imgUrl || require('@/assets/img_pic2@2x.png')"
                                                        style="width: 137px;height: 126px;" alt="">
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                    <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown"
                                        @toUp="toUp" @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
                                </div>
                                <!-- 优惠券导航模块 -->
                                <div class="pr mg-bttom"
                                    :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                                    @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                                    @click="handleView(index)" v-if="item.modelType == 9">
                                    <div style="overflow-x:auto;">
                                        <div style="display:flex;">
                                            <div v-for="(it, inx) in item.modelDetail.couponsList" :key="inx"
                                                class="couponItem" :style="{
                                                    backgroundImage: it.imgUrl ? 'url(' + it.imgUrl + ') ' : ''
                                                }">
                                                <div class="name" v-if="it.imgUrl == ''">{{ it.name || '--' }}</div>
                                                <div class="c-price" v-if="it.imgUrl == '' && it.value && it.limitValue">满{{
                                                    it.limitValue }}减{{ it.value }}</div>
                                                <div class="time" v-if="it.imgUrl == ''">{{ it.startTime || '--' }}至{{
                                                    it.endTime
                                                    || '--' }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown"
                                        @toUp="toUp" @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
                                </div>
                                <!-- 活动商品模块 -->
                                <div class="pr mg-bttom"
                                    :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                                    @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                                    @click="handleView(index)" v-if="item.modelType == 10">
                                    <!-- <div
                                        style="width: 100%;display: flex;align-items: center;justify-content: space-between;padding: 12px 18px;box-sizing: border-box;">
                                        <div style="display: flex;align-items: center;font-size: 12px;color: #F63C56;">
                                            综合
                                            <img style="width: 12px;height: 12px;"
                                                src="@/assets/indexIcon/icon_next_24_2pxred.png" alt="">
                                        </div>
                                        <div style="display: flex;align-items: center;font-size: 12px;color: #333333;">
                                            销量
                                            <img style="width: 12px;height: 12px;margin-left: 4px;"
                                                src="@/assets/indexIcon/icon_next_24black.png" alt="">
                                        </div>
                                        <div style="display: flex;align-items: center;font-size: 12px;color: #333333;">
                                            价格
                                            <img style="width: 12px;height: 12px;margin-left: 4px;"
                                                src="@/assets/indexIcon/icon_next_24black.png" alt="">
                                        </div>
                                    </div> -->
                                    <div style="width: 100%;overflow-y:auto;white-space:nowrap;margin-bottom:10px;"
                                        v-if="item.modelDetail.goodsType == 2">
                                        <div style="padding:4px 15px;border-radius:14px;background-color:#FEF4F5;border:1px solid #F63C56;color:#F63C56;font-size:12px;margin-right:16px;display:inline-block;"
                                            v-if="item.modelDetail.tagList.length > 0">{{ item.modelDetail.tagList[0].name
                                            }}
                                        </div>
                                        <div style="padding:4px 15px;border-radius:14px;background-color:#F5F5F5;font-size:12px;margin-right:16px;display:inline-block;"
                                            v-for="(itemx, indexx) in item.modelDetail.tagList" :key="indexx"
                                            v-if="indexx > 0">
                                            {{ itemx.name }}
                                        </div>
                                    </div>
                                    <div class="phone-goods" v-if="item.modelDetail.goodsType == 1">
                                        <div class="phone-goods-item" v-for="itemx in item.modelDetail.viewGoodsList">
                                            <img :src="itemx.imgUrl || itemx.mainImage || itemx.image" alt=""
                                                class="phone-goods-img" />
                                            <div class="phone-goods-title">
                                                <div v-if="itemx.resultType == 2" class="gift-tips">礼包</div>
                                                {{ itemx.name }}
                                            </div>
                                            <div class="phone-goods-price">
                                                <div style="display:flex;justify-content:space-between">
                                                    <div style="font-size: 16px;color: #F63C56;">￥{{ itemx.price }}
                                                    </div>
                                                    <div class="discount">{{ itemx.discount }}折
                                                    </div>
                                                </div>
                                                <div style="display:flex;justify-content:space-between">
                                                    <p style="font-size: 11px;color: #999999;text-decoration:line-through">
                                                        ￥{{ itemx.marketPrice }}
                                                    </p>
                                                    <p class="market-price">已售{{ itemx.saleNum }}</p>
                                                </div>
                                                <div
                                                    style="display:flex;justify-content:space-between;padding-right:1px;padding-left:4px;align-items:center;width:84px;height:14px;background:linear-gradient(91deg, #F63C56 0%, #FF006F 100%)">
                                                    <div class="share">分享赚</div>
                                                    <div class="sharePrice">￥{{ itemx.income }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="phone-goods" v-else>
                                        <div class="phone-goods-item" v-for="itemx in item.modelDetail.tagGoodsList">
                                            <img :src="itemx.imgUrl || itemx.headImg || itemx.image" alt=""
                                                class="phone-goods-img" />
                                            <div class="phone-goods-title">
                                                <div v-if="itemx.resultType == 2" class="gift-tips">礼包</div>{{ itemx.name }}
                                            </div>
                                            <!-- <div class="phone-goods-price">
                                                <p class="retail-price">
                                                    <span style="font-size: 10px">￥</span>{{ itemx.price }}
                                                </p>
                                                <p class="market-price">已售{{ itemx.saleNum }}</p>
                                            </div> -->
                                            <div class="phone-goods-price">
                                                <div style="display:flex;justify-content:space-between">
                                                    <div style="font-size: 16px;color: #F63C56;">￥{{ itemx.price }}
                                                    </div>
                                                    <div class="discount">{{ itemx.discount }}折
                                                    </div>
                                                </div>
                                                <div style="display:flex;justify-content:space-between">
                                                    <p style="font-size: 11px;color: #999999;text-decoration:line-through">
                                                        ￥{{ itemx.marketPrice }}
                                                    </p>
                                                    <p class="market-price">已售{{ itemx.saleNum }}</p>
                                                </div>
                                                <div
                                                    style="display:flex;justify-content:space-between;padding-right:1px;padding-left:4px;align-items:center;width:84px;height:14px;background:linear-gradient(91deg, #F63C56 0%, #FF006F 100%)">
                                                    <div class="share">分享赚</div>
                                                    <div class="sharePrice">￥{{ itemx.income }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown"
                                        @toUp="toUp" @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
                                </div>
                                <!-- 图片导航模块 -->
                                <div class="pr1 mg-bttom"
                                    :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                                    @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                                    @click="handleView(index)" v-if="item.modelType == 11">
                                    <img v-if="item.modelDetail.imgList.length == 1" :src="itemx.imgUrl ||
                                        require('@/assets/img_pic2@2x.png')
                                        " alt="" class="active-img1"
                                        v-for="(itemx, indexx) in item.modelDetail.imgList" :key="indexx" />
                                    <div v-if="item.modelDetail.imgList.length != 1">
                                        <el-carousel indicator-position="none" arrow="never" height="124px">
                                            <el-carousel-item v-for="(sItem, sIndex) in item.modelDetail.imgList"
                                                :key="sIndex">
                                                <img :src="sItem.imgUrl" style="width: 100%;height: 100%;" alt="" />
                                            </el-carousel-item>
                                        </el-carousel>
                                    </div>
                                    <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown"
                                        @toUp="toUp" @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
                                </div>
                                <!-- 商品排行榜模块 -->
                                <div class="pr mg-bttom"
                                    :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                                    @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                                    @click="handleView(index)" v-if="item.modelType == 12">
                                    <div class="goodFirst">
                                        <div style="display:flex;">
                                            <div v-for="(it, inx) in item.modelDetail.goodsList" :key="inx"
                                                class="goods-Item">
                                                <img style="width:143px;height: 143px;z-index:9;position:absolute;left:0px;top:0px"
                                                    v-if="it.image != ''"
                                                    src="https://fenxiao.muruji.com/internalSystem/0a35b9c5-8a21-4816-a3cc-8bc9d0dd4f54" />
                                                <img v-if="it.image != ''"
                                                    style="width:143px;height: 143px;z-index:8;position:absolute;left:0px;top:0px;border-radius: 6px;"
                                                    :src="it.image" />
                                                <img v-if="it.image == ''" style="width:143px;height: 143px;z-index:9"
                                                    src="https://fenxiao.muruji.com/internalSystem/d6aa7641-aa6d-44e7-a598-ea6656814b36" />
                                                <div style="height: 151px;" v-if="it.image != ''"></div>
                                                <div class="goods-Item-num">
                                                    NO.{{ inx + 1 }}
                                                </div>
                                                <div class="goods-Item-status">已售罄</div>
                                                <div style="position: relative;height: 20px;overflow-y: hidden;">
                                                    <img src="https://fenxiao.muruji.com/internalSystem/5751ffec-2668-4e16-becf-65409ef27cc7"
                                                        style="width: 36px;height: 16px;margin-right: 14px;float: left;position:absolute;top:4px" />
                                                    <span
                                                        style="font-weight: bold;font-size: 12px;color: #333333;margin-left: 42px;">{{
                                                            it.name }}</span>
                                                </div>
                                                <div
                                                    style="display: flex;justify-content: space-between;align-items: center;width: 100%;height: 16px;margin-top: 4px;">
                                                    <div class="g-discount" v-if="it.discount">{{ it.discount }}折</div>
                                                    <div class="g-sale">已售{{ it.saleNum }}件</div>
                                                </div>
                                                <div
                                                    style=" margin-left: 6px;width: 131px;height: 44px;background: #FFF0F6;border-radius: 6px 6px 6px 6px;margin-top:8px; box-sizing: border-box;display: flex;justify-content: space-between;align-items: center;">
                                                    <div style="margin-left: 5px;">
                                                        <div style="color: #F63C56;font-weight: bold;">
                                                            <span style="font-size: 10px;">￥</span>
                                                            <span style="font-size: 15px;">{{
                                                                String(it.marketPrice || '').split('.')[0] || '0'
                                                            }}</span>
                                                            <span style="font-size: 10px;">.{{
                                                                String(it.marketPrice).split('.')[1] || '00' }}</span>
                                                        </div>
                                                        <div
                                                            style="font-size: 10px;color: #999999;text-decoration:line-through">
                                                            ￥{{ it.price }}
                                                        </div>
                                                    </div>
                                                    <div style="margin-top: 6px;"><img style="width: 44px;height: 44px;"
                                                            src="https://fenxiao.muruji.com/internalSystem/45c622ff-37e6-4b08-8721-e82c707da6ab" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown"
                                        @toUp="toUp" @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
                                </div>
                            </div>
                            <div class="nav" v-if="isView && navForm.isShow == '1' && navForm.position == '1'">
                                <div @click="isHide = !isHide">
                                    <div v-if="isHide && navForm.hideStyle == ''" class="isShow">
                                        <div class="isShowText">收起</div>
                                        <img src="https://fenxiao.muruji.com/internalSystem/39138afd-2221-45f7-9648-a480b5156448"
                                            style="width: 16px;height: 16px;" />
                                    </div>
                                    <div v-if="isHide && navForm.hideStyle != ''">
                                        <img :src="navForm.hideStyle" style="width: 44px;height: 44px;" />
                                    </div>
                                    <div v-if="!isHide && navForm.showStyle == ''" class="isShow">
                                        <div class="isShowText">展开</div>
                                        <img src="https://fenxiao.muruji.com/internalSystem/477268b8-778a-4110-b635-704cbb146ae0"
                                            style="width: 16px;height: 16px;" />
                                    </div>
                                    <div v-if="!isHide && navForm.showStyle != ''">
                                        <img :src="navForm.showStyle" style="width: 44px;height: 44px;" />
                                    </div>

                                </div>
                                <div class="nav-content" v-if="isHide && navViewList.length != 0">
                                    <div>
                                        <div style="height: 12px;"></div>
                                        <div v-for="(itm, idx) in navViewList" :key="idx" class="nav-item"
                                            @click="changeIndex(idx, itm)"
                                            :class="{ 'nav-item-active': currentIndex == idx && itm.inx != -1 && !isIcon }"
                                            :style="{ lineHeight: itm.inx == '-1' ? '0px' : '44px', marginTop: itm.inx != '-1' && itm.icon != '' ? (navForm.margin || 0) + 'px' : '0px', marginBottom: itm.inx != '-1' && itm.icon != '' ? (navForm.margin || 0) + 'px' : '0px' }">
                                            <div v-if="itm.inx != '-1' && !isIcon">
                                                <span
                                                    v-if="navForm.topList[0].position == '1' && navForm.topList[0].relative">{{
                                                        Number(idx) }}F</span>
                                                <span v-else>{{ Number(idx + 1) }}F</span>
                                            </div>
                                            <div v-else-if="itm.inx != '-1' && isIcon">
                                                <img style="width: 44px;height: 44px;" :src="itm.icon" />
                                            </div>
                                            <div v-else style="height: 44px;">
                                                <img v-if="!isIcon"
                                                    src="https://fenxiao.muruji.com/internalSystem/cf9def67-9f5e-4ad3-b645-2355ffc04bb9"
                                                    style="width: 20px;height: 20px;margin-top: 4px;" />
                                                <div v-if="!isIcon"
                                                    style="font-size: 10px;color: #333333;text-align: center;margin-top: 8px;">
                                                    置顶</div>
                                                <img v-if="isIcon" style="width: 44px;height: 44px;" :src="itm.icon" />
                                            </div>
                                        </div>
                                        <div
                                            style="height: 12px;background-color: white;width:44px;border-bottom-left-radius: 12px">
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="nav-left" v-if="isView && navForm.isShow == '1' && navForm.position == '0'">
                                <div class="nav-content" v-if="isHide && navViewList.length != 0">
                                    <div style="height: 12px;"></div>
                                    <div>
                                        <div v-for="(itm, idx) in navViewList" :key="idx" class="nav-item"
                                            @click="changeIndex(idx, itm)"
                                            :class="{ 'nav-item-active': currentIndex == idx && itm.inx != -1 && !isIcon }"
                                            :style="{ lineHeight: itm.inx == '-1' ? '0px' : '44px', marginTop: itm.inx != '-1' && itm.icon != '' ? (navForm.margin || 0) + 'px' : '0px', marginBottom: itm.inx != '-1' && itm.icon != '' ? (navForm.margin || 0) + 'px' : '0px' }">
                                            <div v-if="itm.inx != '-1' && !isIcon">
                                                <span
                                                    v-if="navForm.topList[0].position == '1' && navForm.topList[0].relative">{{
                                                        Number(idx) }}F</span>
                                                <span v-else>{{ Number(idx + 1) }}F</span>
                                            </div>
                                            <div v-else-if="itm.inx != '-1' && isIcon">
                                                <img style="width: 44px;height: 44px;" :src="itm.icon" />
                                            </div>
                                            <div v-else style="height: 44px;">
                                                <img v-if="!isIcon"
                                                    src="https://fenxiao.muruji.com/internalSystem/cf9def67-9f5e-4ad3-b645-2355ffc04bb9"
                                                    style="width: 20px;height: 20px;margin-top: 4px;" />
                                                <div v-if="!isIcon"
                                                    style="font-size: 10px;color: #333333;text-align: center;margin-top: 8px;">
                                                    置顶</div>
                                                <img v-if="isIcon" style="width: 44px;height: 44px;" :src="itm.icon" />
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        style="height: 12px;background-color: white;width:44px;border-bottom-right-radius: 12px">
                                    </div>
                                </div>
                                <div @click="isHide = !isHide">
                                    <div v-if="isHide && navForm.hideStyle == ''" class="isShow">
                                        <div class="isShowText">收起</div>
                                        <img src="https://fenxiao.muruji.com/internalSystem/39138afd-2221-45f7-9648-a480b5156448"
                                            style="width: 16px;height: 16px;" />
                                    </div>
                                    <div v-if="isHide && navForm.hideStyle != ''">
                                        <img :src="navForm.hideStyle" style="width: 44px;height: 44px;" />
                                    </div>
                                    <div v-if="!isHide && navForm.showStyle == ''" class="isShow">
                                        <div class="isShowText">展开</div>
                                        <img src="https://fenxiao.muruji.com/internalSystem/477268b8-778a-4110-b635-704cbb146ae0"
                                            style="width: 16px;height: 16px;" />
                                    </div>
                                    <div v-if="!isHide && navForm.showStyle != ''">
                                        <img :src="navForm.showStyle" style="width: 44px;height: 44px;" />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="page-right" v-if="viewData.length > 0 && viewIndex > -1">
                    <div style="display: flex;">
                        <div class="page-right-title">是否显示</div>
                        <div> <el-radio v-model="navForm.isShow" label="1">是</el-radio>
                            <el-radio v-model="navForm.isShow" label="0">否</el-radio>
                        </div>
                    </div>
                    <div class="nav-title" v-if="navForm.isShow == '1'">导航内容</div>
                    <div class="nav-info" v-if="navForm.isShow == '1'">
                        （注：图标尺寸大小为88px*88px，上传大小不得超过50k，支持jpg、jpeg、png格式，若已开启的图标其中一个上传失败，或者没有上传，则上传的图标统一不生效，统一使用默认样式。）
                    </div>
                    <div style="margin-top: 12px;border-left: 0.5px solid #e9e6e6;border-right: 0.5px solid #e9e6e6;"
                        v-if="navForm.isShow == '1'">
                        <el-table :data="navForm.topList" :header-cell-style="{
                            background: '#F5F6FA',
                            color: '#303033',
                            'font-weight': 'bold',
                            'text-align': 'left',
                        }
                            ">
                            <el-table-column label="置顶图标位置">
                                <template slot='header' slot-scope="scope">
                                    <div style="font-size: 14px;text-align: left;">置顶图标位置</div>
                                </template>
                                <template slot-scope="scope">
                                    <div style="text-align: left;">
                                        <el-radio-group v-model="scope.row.position" @input="changeTop($event)">
                                            <el-radio label="1">导航最上方</el-radio>
                                            <el-radio label="0">导航最下方</el-radio>
                                        </el-radio-group>

                                    </div>

                                </template>
                            </el-table-column>
                            <el-table-column label="是否关联">
                                <template slot='header' slot-scope="scope">
                                    <div style="font-size: 14px;text-align: center;">是否关联</div>
                                </template>
                                <template slot-scope="scope">
                                    <el-switch v-model="scope.row.relative" @change="changeTopRelative"
                                        active-color="#2D46EE" inactive-color="#EBEEFA">
                                    </el-switch>
                                </template>
                            </el-table-column>
                            <el-table-column label="上传图标" prop="imgUrl">
                                <template slot='header' slot-scope="scope">
                                    <div style="font-size: 14px;text-align: center;">上传图标</div>
                                </template>
                                <template slot-scope="scope">
                                    <upload-picture :imageUrl="scope.row.icon" :isDisabled="scope.row.relative == 0"
                                        @getUrl="getImage($event, 'top')"></upload-picture>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div style="margin-top: 19px;border-left: 0.5px solid #e9e6e6;border-right: 0.5px solid #e9e6e6;"
                        v-if="navForm.isShow == '1'">
                        <el-table :data="navForm.contentList" :header-cell-style="{
                            background: '#F5F6FA',
                            color: '#303033',
                            'font-weight': 'bold',
                            'text-align': 'left',
                        }
                            ">
                            <el-table-column label="楼层序号" width="200px">
                                <template slot-scope="scope">
                                    <div>{{ scope.row.inx }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column label="上传图标" prop="imgUrl">
                                <template slot='header' slot-scope="scope">
                                    <div style="font-size: 14px;text-align: center;">上传图标</div>
                                </template>
                                <template slot-scope="scope">
                                    <upload-picture :imageUrl="scope.row.icon" :isDisabled="scope.row.relative == 0"
                                        @getUrl="getImage($event, 'content', scope.$index)"></upload-picture>
                                </template>
                            </el-table-column>
                            <el-table-column label="是否关联">
                                <template slot='header' slot-scope="scope">
                                    <div style="font-size: 14px;text-align: center;">是否关联</div>
                                </template>
                                <template slot-scope="scope">
                                    <el-switch @change="changeContentRelative($event, scope.$index)"
                                        v-model="scope.row.relative" active-color="#2D46EE" inactive-color="#EBEEFA">
                                    </el-switch>
                                </template>
                            </el-table-column>

                        </el-table>
                    </div>
                    <div style="margin-top: 24px;" v-if="navForm.isShow == '1'">
                        <el-form ref="navForm" label-width="126px" class="info-form" :model="navForm">
                            <div style="display:flex">
                                <el-form-item label="展开按钮样式" prop="showStyle">
                                    <div slot="label" style="line-height: 64px;">
                                        展开按钮样式
                                    </div>
                                    <div style="display: flex;">
                                        <upload-picture :imageUrl="navForm.showStyle"
                                            @getUrl="getImageShow($event, 'isShow')"></upload-picture>
                                        <div class="image-info">
                                            （图片尺寸大小为88*88px，上传大小不得超过80k，支持jpg、jpeg、png格式，若不成功上传导航条则使用默认样式.）</div>
                                    </div>
                                </el-form-item>
                                <el-form-item label="隐藏按钮样式" prop="hideStyle">
                                    <div slot="label" style="line-height: 64px;">
                                        隐藏按钮样式
                                    </div>
                                    <div style="display: flex;">
                                        <upload-picture :imageUrl="navForm.hideStyle"
                                            @getUrl="getImageShow($event, 'isHide')"></upload-picture>
                                        <div class="image-info">
                                            （图片尺寸大小为88*88px，上传大小不得超过80k，支持jpg、jpeg、png格式，若不成功上传导航条则使用默认样式.）</div>
                                    </div>
                                </el-form-item>
                            </div>
                            <div style="display: flex;width: 100%;justify-content: flex-start;margin-top: 16px;">
                                <el-form-item label="图标上下间距" prop="margin">
                                    <div slot="label" style="height: 38px;">
                                        <div style="line-height: 19px;">图标上下间距</div>
                                        <div style="line-height: 19px;color: #909099;">（单位px）</div>
                                    </div>
                                    <el-input v-model="navForm.margin"
                                        oninput="value=value.replace(/^0|[^0-9]/g,'');if(value>10)value=10;if(value<0)value=0"
                                        placeholder="请输入，不输入则为0间距，输入范围0-10" style="width: 295px;" size="small"></el-input>
                                </el-form-item>
                                <el-form-item label="触发导航楼层序号" prop="navIndex" style="margin-left: 200px;">
                                    <el-select style="width: 295px;" size="small" placeholder="请选择" @change="changeNavIndex"
                                        v-model="navForm.navIndex">
                                        <el-option v-for="item in navForm.contentList" :key="item.inx" :label="item.inx"
                                            :value="item.inx">
                                        </el-option>
                                    </el-select>

                                </el-form-item>
                            </div>
                            <el-form-item label="导航栏位置" prop="position" style="margin-top: 16px;">
                                <el-radio-group v-model="navForm.position">
                                    <el-radio label="1">固定右边</el-radio>
                                    <el-radio label="0">固定左边</el-radio>
                                </el-radio-group>
                                <!-- <el-radio v-model="navForm.position" label="1">固定右边</el-radio>
                                <el-radio v-model="navForm.position" label="0">固定左边</el-radio> -->
                            </el-form-item>
                            <el-form-item label="是否显示分享" prop="isShare" style="margin-top: 16px;">
                                <el-radio-group v-model="navForm.isShare">
                                    <el-radio label="1">是</el-radio>
                                    <el-radio label="0">否</el-radio>
                                </el-radio-group>
                                <!-- <el-radio v-model="navForm.position" label="1">固定右边</el-radio>
                                <el-radio v-model="navForm.position" label="0">固定左边</el-radio> -->
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <!-- <div class="bottom-box">
                <div class="bottom-btn" @click="saveIndexTemplate">保存</div>
            </div> -->
        </div>

    </div>
</template>
<script>
import breadcrumbTop from '@/components/breadcrumb.vue'
import breadcrumbSearch from '@/components/breadcrumbSearch.vue'
import toolBar from '@/components/toolBar2.vue'
import uploadPicture from '@/components/upload/mallPicture3.vue'
export default {
    components: {
        breadcrumbTop,
        breadcrumbSearch,
        toolBar,
        uploadPicture
    },
    props: {
        activityId: Number,
        activityType: String,
    },
    data() {
        return {
            isView: true,
            currentIndex: 0,
            navForm: {
                showStyle: '',
                hideStyle: '',
                margin: '',
                navIndex: '',
                position: '1',
                isShow: '0',
                bgColor: '',
                isShare: '1',
                topList: [
                    {
                        position: '1',
                        relative: true,
                        icon: ''
                    }
                ],
                contentList: [
                    // {
                    //     inx: '01',
                    //     icon: '',
                    //     relative: true,
                    // },
                    // {
                    //     inx: '02',
                    //     icon: '',
                    //     relative: true,
                    // },
                    // {
                    //     inx: '03',
                    //     icon: '',
                    //     relative: true,
                    // }
                ],
            },
            contentList: [
                {
                    inx: '01',
                    icon: '',
                    relative: true,
                },
                {
                    inx: '02',
                    icon: '',
                    relative: true,
                },
                {
                    inx: '03',
                    icon: '',
                    relative: true,
                }
            ],
            isShow: '1',
            coupons: [
                // {}, {}, {}, {}, {}, {}
            ],
            tagActiveId: null,
            tagDialog: false,
            modulBox: false,
            goodsType: 1,
            goodsType1: 1,
            pageType: 1,
            dataList: {
                list: [
                    { title: 'APP设置', path: '', type: '0' },
                    { title: '首页装修', path: '', type: '1' }
                ]
            },
            popData: [
                {
                    imgUrl: '',
                    navType: 0,
                    funcName: '',
                    navUrl: '',
                    id: ''
                }
            ],
            dialogVisible: false,
            delDialogVisible: false,
            functionLeft: ['无', '功能入口', '商品', '页面/活动'],
            functionIndex: 0,
            radio: '1',
            functionInlet: [
                { label: '1', name: '消息中心' },
                { label: '2', name: '服务商管理' },
                { label: '3', name: '地址管理' },
                { label: '4', name: '银行卡' },
                { label: '5', name: '佣金管理' },
                { label: '6', name: '余额管理' },
                { label: '7', name: '积分商城' },
                { label: '8', name: '粉丝管理' },
                { label: '9', name: '订单中心' },
                { label: '10', name: '加入服务商' }
            ],
            functionInletRadio: '',
            modulList: ['搜索功能', '轮播图', '分类导航', '图片导航', '标题导航', '秒杀导航', '商品导航', '活动导航', '优惠券导航', '活动商品导航', '100%屏幕宽图', '商品排行榜'],
            nav: [1, 2, 3, 4],
            viewData: [],
            delIndex: 0,
            viewIndex: 0,
            goodsPageNo: 1,
            goodsPageSize: 10,
            goodsSelectedId: null,
            goodsInfo: '',
            goodsTotalNum: 0,
            goodsList: [],
            goodsPageNo1: 1,
            goodsPageSize1: 10,
            goodsSelectedId1: null,
            goodsInfo1: '',
            goodsTotalNum1: 0,
            goodsList1: [],
            catePageNo: 1,
            catePageSize: 10,
            categoryName: '',
            cateTotalNum: 0,
            rootCategoryId: '',
            categoryId: '',
            rootCategory: [],
            category: [],
            imageUrl: '',
            rowIndex: 0,
            pageName: '',
            goodsDialogVisible: false,
            goodsDialogVisible1: false,
            selectedGoods: [],
            selectedGoods1: [],
            activeRow: {},
            pid: null,
            radioHeight: '1',
            classifyType: '1',
            labelPageNo: 1,
            labelPageSize: 10,
            tagName: '',
            labelTotalNum: 0,
            labelList: [],
            labelId: null,
            searchForm: {
                title: '', // 	否 	string 	账号名称名称
                status: true,
                createdTimeStart: '',
                createdTimeEnd: '',
                pageNo: 1,
                pageSize: 10
            },
            pageList: [],
            pageTotalNum: 0,
            pageId: null,
            modulData: {},
            nameLabelList: [],
            tagRowIndex: 0,
            tagType: '',
            goodsTagList: [],
            navUrl: '',
            expendAll: false,
            bgColor: '',
            navViewList: [],
            isHide: false,
            isIcon: false,
        }
    },
    created() {
        if (this.activityType == 'edit') {
            // this.getIndexTemplate()
        }
        // this.getLayoutType()
        // this.getLabelList()
        this.getGoodsPage()
        // this.getRootCategoryList()
        this.getPageList()
        this.getGoodsTag()
        this.getFunctionList()
        this.getCoupons()
    },
    mounted() {
        this.$bus.$on('bus-event', (data) => {
            this.navForm.bgColor = data
        })

    },
    methods: {
        //数据处理
        handleR() {
            let viewArr = []
            viewArr = [...this.navForm.contentList]
            let objT = {
                inx: '-1',
                icon: this.navForm.topList[0].icon || '',
                relative: this.navForm.topList[0].relative
            }
            if (this.navForm.topList[0].position == '1') {

                viewArr.unshift(objT)
            } else {
                viewArr.push(objT)
            }
            this.navViewList = viewArr.filter(item => { return item.relative == 1 })
            this.isIcon = this.navViewList.every(item => item.icon != '')
        },
        changeContentRelative(e, index) {
            this.handleR()
        },
        changeTopRelative(e) {
            this.handleR()
            // if (!e) {
            //     this.navViewList = [...this.navForm.contentList]
            // } else {
            //     this.navViewList = [...this.navForm.contentList]
            //     let objT = {
            //         inx: '-1',
            //         icon: this.navForm.topList[0].icon,
            //         relative: this.navForm.topList[0].relative
            //     }
            //     if (this.navForm.topList[0].position == '1') {
            //         this.navViewList.unshift(objT)
            //     } else {
            //         this.navViewList.push(objT)
            //     }
            // }
            // let tempArr = []
            // this.navViewList.forEach(item => {
            //     if (item.relative == 1) {
            //         tempArr.push(item)
            //     }
            // })
            // this.isIcon = temArr.every(item => item.icon != '')
        },
        changeNavIndex() {
            if (this.navForm.navIndex) {
                this.isInViewport('refScroll' + Number(this.navForm.navIndex - 1))
            }

        },
        scrollContent() {
            if (this.navForm.navIndex) {
                this.isInViewport('refScroll' + Number(this.navForm.navIndex - 1))
            }
        },
        changeTop(e) {
            this.handleR()
        },
        isInViewport(element) {
            // const rect = element.getBoundingClientRect();
            // return (
            //     rect.top >= 0 &&
            //     rect.left >= 0 &&
            //     rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            //     rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            // );
            console.log(element, '111')
            const scrollableDiv = document.getElementById('refScroll');
            const observedElement = document.getElementById(String(element));

            const intersectionObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // 元素在可视区域内
                        console.log('元素在可视区域内');
                        this.isView = true
                    } else {
                        // 元素不在可视区域内
                        console.log('元素不在可视区域内');
                        this.isView = false
                    }
                });
            });

            intersectionObserver.observe(observedElement);
        },
        changeIndex(index, item) {
            this.currentIndex = index
            console.log(item)
            this.$nextTick(() => {
                let top = 0
                if (item.inx == '-1') {
                    top = 0
                } else {
                    top = document.getElementById('refScroll' + (Number(item.inx) - 1)).offsetTop - 100
                }
                document.getElementById("refScroll").scrollTo(
                    {
                        top: top,
                        behavior: 'smooth'
                    }
                );

                console.log(this.$refs, document.getElementById('refScroll1'))
                // document.getElementById('refScroll2').scollIntoView({
                //     block: 'start',
                //     behavior: 'smooth'
                // })
                // this.$refs.refScroll3.scollIntoView({
                //     block: 'start',
                //     behavior: 'smooth'
                // })
                // this.$refs.refScroll.scrollTop = document.getElementById('refScroll3').offsetTop;

            })

        },
        selectCoupons(val, index, viewIndex) {
            this.coupons.forEach(row => {
                if (row.id == val) {
                    this.viewData[viewIndex].modelDetail.couponsList[index].id = row.id
                    this.viewData[viewIndex].modelDetail.couponsList[index].name = row.name
                    this.viewData[viewIndex].modelDetail.couponsList[index].limitValue = row.limitValue
                    this.viewData[viewIndex].modelDetail.couponsList[index].value = row.value
                    this.viewData[viewIndex].modelDetail.couponsList[index].startTime = row.startTime.split(' ')[0] || ''
                    this.viewData[viewIndex].modelDetail.couponsList[index].endTime = row.endTime.split(' ')[0] || ''
                }
            })

            console.log(this.viewData[viewIndex].modelDetail.couponsList)
            this.$forceUpdate()
        },
        getCoupons() {
            this.axios.get('/appIndex/couponList').then(res => {
                if (res.code == 0) {
                    // res.data.list.forEach(item => {
                    //   if (item.showFlag == 1) {
                    //     item.showFlagL = '是'
                    //   } else {
                    //     item.showFlagL = '否'
                    //   }
                    // })
                    this.coupons = res.data
                }
            })
        },
        getFunctionList() {
            this.axios.get('/indexTemplate/getFuncList')
                .then(res => {
                    console.log('功能列表==', res)
                    if (res.code == 0) {
                        this.functionInlet = res.data
                    }
                })
        },
        async selectGoodsTagFn(id, disabled) {
            if (!disabled) return
            this.goodsTagList.forEach(item => {
                if (item.id == id) {
                    item.selected = !item.selected;
                }
            })
            let list = this.goodsTagList.filter(item => item.selected)
            console.log('选中的标签===', list)
            if (list.length > 0) {
                this.viewData[this.viewIndex].modelDetail.tagList = list.map(item => {
                    return {
                        id: item.id,
                        name: item.name
                    }
                })
                let ids = this.viewData[this.viewIndex].modelDetail.tagList.map(item => {
                    return item.id
                })
                let goods = await this.getTagGoodsList(ids[0])
                this.viewData[this.viewIndex].modelDetail.tagGoodsList = goods;
                console.log('第一标签商品===', goods)
            } else {
                this.viewData[this.viewIndex].modelDetail.tagGoodsList = []
                this.viewData[this.viewIndex].modelDetail.tagList = []
            }



            // if(ids.length == 0) return

            // console.log(goods)
            console.log('选择的标签ID', this.viewData[this.viewIndex].modelDetail.tagList)
            // tagGoodsList
        },
        async getTagGoodsList(ids) {
            let data = {
                pageNo: 1,
                pageSize: 10,
                tagIds: [ids]
            }
            let res = await this.axios.post('/appIndex/searchGoods', data)
            console.log('根据标签获取商品', res)
            if (res.code == 0) {
                return res.data.list
                // if(res.data.list.length == 0){
                //   this.$message.warning('')
                // }
                //this.viewData[this.viewIndex].modelDetail.tagGoodsList = res.data.list;
            }
        },
        getGoodsTag() {
            let data = {
                status: 1,
                pageNo: 1,
                pageSize: 1000
            }
            this.axios.post('/tagPool/show/pageList', data)
                .then(async res => {
                    console.log('商品标签', res)
                    if (res.code == 0) {
                        res.data.list.forEach(item => {
                            item.selected = false
                            item.disabled = false
                        })
                        this.goodsTagList = res.data.list;
                        let ids = this.goodsTagList.map(item => {
                            return item.id
                        })
                        let list = await this.getEnableTags(ids)
                        console.log('需要标签', list)
                        this.goodsTagList.forEach(item => {
                            list.forEach(val => {
                                if (item.id == val.id) {
                                    item.disabled = true
                                }
                            })
                        })
                        console.log('对比标签', this.goodsTagList)
                    }

                })
        },
        async confirmTag() {
            if (this.tagActiveId) {
                this.viewData[this.viewIndex].modelDetail.labelList[this.tagRowIndex].labelId = this.tagActiveId
                this.nameLabelList.forEach(item => {
                    if (item.id == this.tagActiveId) {
                        this.viewData[this.viewIndex].modelDetail.labelList[this.tagRowIndex].labelName = item.name
                    }
                })
            }
            console.log('哈哈哈', this.tagActiveId)
            if (this.viewData[this.viewIndex].modelType == 9) {
                console.log('名义', this.viewData[this.viewIndex])
                let ids = this.viewData[this.viewIndex].modelDetail.labelList[0].labelId
                let list = await this.getTagGoodsList(ids)
                this.viewData[this.viewIndex].modelDetail.labelList[0].goodsList = list;
                console.log(list)
            }
            // this.getTagGoods(this.tagActiveId)
            this.tagDialog = false;

        },
        getTagGoods(tagId) {
            let data = {
                status: '',
                categoryIds: '',
                tagLevel2: [tagId],
                pageNo: 1,
                pageSize: 4
            }
            this.axios.post('/goods/pageList', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        if (this.tagType == 'name' || this.tagType == 'people') {
                            this.viewData[this.viewIndex].modelDetail.labelList[this.tagRowIndex].goodsList = res.data.list
                        }
                        console.log(this.viewData[this.viewIndex].modelDetail.labelList)
                    }

                })
        },
        selectTagFn(id) {
            this.tagActiveId = id;
        },
        showTagDialog(viewIndex, index, labelId, type) {

            this.viewIndex = viewIndex;
            this.tagActiveId = labelId;
            this.tagRowIndex = index;
            this.tagType = type;
            // this.viewData[viewIndex].modelDetail.labelList[index].labelId = 
            console.log(labelId)
            this.getLabelType(type)
        },
        getLabelType(type) {
            this.axios.post('/tagPool/filter/categoryList')
                .then(res => {
                    console.log('标签飞得更高', res)
                    if (res.code == 0) {
                        res.data.forEach(item => {
                            let dictId;
                            if (type == 'name') {
                                if (item.dictName.indexOf('名义') > -1) {
                                    dictId = item.dictId
                                    this.tagPoolList(dictId)
                                }
                            }
                            if (type == 'people') {
                                if (item.dictName.indexOf('人群') > -1) {
                                    dictId = item.dictId
                                    this.tagPoolList(dictId)
                                }
                            }


                        })
                    }
                })
        },
        tagPoolList(id) {
            let data = {
                tagId: id,
                pageNo: 1,
                pageSize: 1000
            }
            this.axios.post('/tagPool/filter/pageList', data)
                .then(res => {
                    console.log(res)
                    this.nameLabelList = res.data.list;
                    this.tagDialog = true;
                })
        },
        titleFn() {
            this.modulBox = false;
            console.log('标题设置', this.modulData)
            Object.keys(this.modulData).forEach(item => {
                this.viewData[this.viewIndex][item] = this.modulData[item]
            })
            this.viewData[this.viewIndex].pageId = this.pageId;
            this.viewData[this.viewIndex].pageType = this.pageType;

            this.$forceUpdate()
        },
        showModulSetting(viewIndex, type) {
            this.modulBox = true;
            this.viewIndex = viewIndex;
            let data = {
                title: this.viewData[viewIndex].title,
                subTitle: this.viewData[viewIndex].subTitle,
                btnTitle: this.viewData[viewIndex].btnTitle,
                navType: this.viewData[viewIndex].navType,
                funcName: this.viewData[viewIndex].funcName,
                navUrl: this.viewData[viewIndex].navUrl
            }
            this.modulData = data;
            // this.viewData[viewIndex]
        },
        selectPageType(type) {
            this.pageType = type
            this.searchForm.pageNo = 1;
            this.getPageList()
        },
        selectType(type) {
            this.goodsType = type
            this.goodsPageNo = 1;
            this.getGoodsPage()
        },
        selectType1(type) {
            this.goodsType1 = type
            this.goodsPageNo1 = 1;
            this.getGoodsPage1()
        },
        getPageList() {
            let url = '/appIndex/pageList'
            if (this.pageType == 1) {
                url = '/appIndex/pageList'
                this.searchForm.status = true
            } else {
                url = '/marketActivate/pageList'
                this.searchForm.name = this.searchForm.title;
                this.searchForm.status = 1;
            }
            this.axios.post(url, this.searchForm)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.pageList = res.data.list;
                        this.pageTotalNum = res.data.totalNum;
                    }
                })
        },
        handleSizeChangePage(e) {
            this.searchForm.pageSize = e;
            this.searchForm.pageNo = 1;
            this.getPageList()
        },
        handleCurrentChangePage(e) {
            this.searchForm.pageNo = e;
            this.getPageList()
        },
        handleSizeChangeLabel(e) {
            this.labelPageSize = e;
            this.labelPageNo = 1;
            this.getLabelList()
        },
        handleCurrentChangeLabel(e) {
            this.labelPageNo = e;
            this.getLabelList()
        },
        getLabelList() {
            let data = {
                pageNo: this.labelPageNo,
                pageSize: this.labelPageSize,
                tagName: this.tagName,
                status: true
            }
            this.axios.post('/tags/pageList', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.labelList = res.data.list;
                        this.labelTotalNum = res.data.totalNum
                    }
                })
        },
        getLayoutType() {
            this.axios.get('/sys/index/getLayoutType')
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.classifyType = res.data + '';
                        if (this.classifyType == '1') {
                            this.functionLeft[2] = '分类类目'
                        } else if (this.classifyType == '2') {
                            this.functionLeft[2] = '分类标签'
                        }
                    }
                })
        },
        saveIndexTemplate() {
            console.log(this.viewData)

            let data = {
                activityId: this.activityId,
                modelJsonStr: JSON.stringify(this.navForm),
                type: '3'
            }
            this.axios.post('/indexTemplate/save', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        // this.getIndexTemplate()
                        // this.$message.success('保存成功')
                    } else {
                        this.$message.warning(res.message)
                    }
                })
        },
        async goodsConfirmFn() {
            console.log('选择的商品', this.selectedGoods)
            if (this.selectedGoods.length > 0) {
                this.viewData[this.viewIndex].modelDetail.goodsList = this.viewData[this.viewIndex].modelDetail.goodsList.concat(this.selectedGoods)
                this.viewData[this.viewIndex].modelDetail.goodsList = this.removeArray(this.viewData[this.viewIndex].modelDetail.goodsList, 'itemNo')
                this.viewData[this.viewIndex].modelDetail.idList = this.viewData[this.viewIndex].modelDetail.goodsList.map(item => {
                    return item.itemNo
                })
                console.log(await this.getGoodsList(this.viewData[this.viewIndex].modelDetail.idList))
                let list = await this.getGoodsList(this.viewData[this.viewIndex].modelDetail.idList)

                this.$nextTick(() => {
                    this.viewData[this.viewIndex].modelDetail.viewGoodsList = list
                    console.log(this.viewData)
                })

            }
            this.goodsDialogVisible = false
        },
        async goodsConfirmFn1() {
            console.log('选择的商品', this.selectedGoods1)
            if (this.selectedGoods1.length > 0) {
                this.viewData[this.viewIndex].modelDetail.goodsList = this.viewData[this.viewIndex].modelDetail.goodsList.concat(this.selectedGoods1)
                this.viewData[this.viewIndex].modelDetail.goodsList = this.removeArray(this.viewData[this.viewIndex].modelDetail.goodsList, 'goodsNo')
                console.log(this.viewData[this.viewIndex].modelDetail.goodsList)
                this.viewData[this.viewIndex].modelDetail.idList = this.viewData[this.viewIndex].modelDetail.goodsList.map(item => {
                    return item.goodsNo
                })
                console.log(this.viewData[this.viewIndex].modelDetail.idList)
                let list = await this.getGoodsList1(this.viewData[this.viewIndex].modelDetail.idList)

                this.$nextTick(() => {
                    this.viewData[this.viewIndex].modelDetail.viewGoodsList = list
                    console.log(this.viewData)
                })

            }
            this.goodsDialogVisible1 = false
        },
        showGoodsDialog(viewIndex) {
            this.goodsDialogVisible = true;
            this.viewIndex = viewIndex;
            this.goodsInfo = ''
            this.searchGoods()
        },
        showGoodsDialog1(viewIndex) {
            this.goodsDialogVisible1 = true;
            this.viewIndex = viewIndex;
            this.goodsInfo1 = ''
            this.searchGoods1()
        },
        removeArray(arr, key) {
            let temp = [];
            arr.forEach(function (a) {
                var check = temp.every(function (b) {
                    return a[key] !== b[key];
                })
                check ? temp.push(a) : ''
            })
            return temp;
        },
        handleSelectionChange(e) {
            this.selectedGoods = e;
        },
        handleSelectionChange1(e) {
            this.selectedGoods1 = e;
        },
        getShowType(e, viewIndex, rowIndex) {
            //console.log(e)showType
            // console.log(,this.viewData[viewIndex])
            //     return
            let changeIndex = Number(this.viewIndex + '')
            this.viewIndex = -1
            rowIndex = rowIndex - 1;

            if (e == 5) {

                if (this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].children) {
                    delete this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].children
                }

            }
            if (e == 2 || e == 3) {
                let navModel = {
                    navType: 0, //1-功能跳转，2-分类标签，3-商品
                    funcName: '无',
                    navUrl: '',
                    id: null //功能、分类或商品id
                }
                console.log(rowIndex)
                console.log('这是id=', this.viewData[viewIndex].modelDetail.activityNavList)
                // return

                if (e == 2) {
                    console.log(this.viewData[viewIndex], '6666')
                    let children = [{
                        id: this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].id + 10,
                        showType: 3,
                        imgUrl: '',
                        navModel: navModel,
                        index: 0
                    }]
                    this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].children = children;
                } else {
                    // rowIndex = rowIndex - 1;
                    if (!this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].children || this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].children.length == 0) {
                        let data = {
                            id: this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].id + 10,
                            showType: 3,
                            imgUrl: '',
                            navModel: navModel,
                            index: 0
                        }
                        let data2 = JSON.parse(JSON.stringify(data))
                        data2.id = this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].id + 110
                        data2.index = 1;
                        this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].children = [data, data2]

                    } else {
                        let data = {
                            id: this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].id + 110,
                            showType: 3,
                            imgUrl: '',
                            navModel: navModel,
                            index: 1
                        }
                        this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].children.push(data)
                    }
                }

                // if(!this.viewData[viewIndex].modelDetail.activityNavList[rowIndex + 1] || this.viewData[viewIndex].modelDetail.activityNavList[rowIndex + 1].showType != 3){
                //     this.viewData[viewIndex].modelDetail.activityNavList.splice(rowIndex + 1,0,data)
                // }
            }
            this.viewData[viewIndex].modelDetail.activityNavList = JSON.parse(JSON.stringify(this.viewData[viewIndex].modelDetail.activityNavList))
            this.$forceUpdate()
            this.$nextTick(() => {
                this.viewIndex = changeIndex
            })
            let arr = this.viewData[viewIndex].modelDetail.activityNavList
            console.log(arr)
        },
        addNav(viewIndex, modelType) {
            console.log(viewIndex, modelType, '111122')
            //modelType==1-搜索功能，2-轮播图，3-分类导航，4-图片导航，5-标题导航，6-活动导航，7-商品导航
            let navModel = {
                navType: 0, //1-功能跳转，2-分类标签，3-商品
                funcName: '无',
                navUrl: '',
                id: null //功能、分类或商品id
            }
            if (modelType == 2) {
                if (this.viewData[this.viewIndex].modelDetail.swiperImageList.length == 10) {
                    this.$message.warning('最多只能添加10张图片')
                    return
                }
                let data = {
                    imgName: '',
                    imgUrl: '',
                    navModel: navModel
                }
                this.viewData[this.viewIndex].modelDetail.swiperImageList.push(data)
            }
            if (modelType == 3) {
                let data = {
                    categoryNavName: '',
                    imgUrl: '',
                    navModel: navModel
                }
                this.viewData[this.viewIndex].modelDetail.categoryNavList.push(data)
            }
            if (modelType == 4) {
                let data = {
                    imgUrl: '',
                    navModel: navModel
                }
                this.viewData[this.viewIndex].modelDetail.imgList.push(data)
            }
            if (modelType == 6 || modelType == 8) {
                let idx = this.viewData[this.viewIndex].modelDetail.activityNavList.length - 1;
                let data = {
                    id: this.viewData[this.viewIndex].modelDetail.activityNavList.length > 0 ? this.viewData[this.viewIndex].modelDetail.activityNavList[idx].id + 1 : 1,
                    imgUrl: '',
                    showType: 5,
                    oneLan: 1,
                    navModel: navModel
                }
                this.viewData[this.viewIndex].modelDetail.activityNavList.push(data)
            }
            if (modelType == 9) {
                let data = {
                    id: '',
                    name: '',
                    limitValue: '',
                    value: '',
                    startTime: '',
                    endTime: '',
                    imgUrl: '',
                    imgUrl1: '',
                    imgUrl2: '',

                }
                this.viewData[this.viewIndex].modelDetail.couponsList.push(data)
                console.log(this.viewData[this.viewIndex].modelDetail.couponsList)
            }
            if (modelType == 12) {
                let data = {
                    goods: {},
                    navModel: navModel
                }
                this.viewData[this.viewIndex].modelDetail.viewGoodsList.push(data)
            }
            this.$forceUpdate()
        },
        getFunctionName(name, url) {
            this.pageName = name;
            this.navUrl = url;
            console.log('nameUrl==', name, url)
        },
        async confirmFn() {
            let funcName = '无';
            let rootCategoryId = '';
            let categoryId = '';
            let goodsSelectedId = '';
            let navUrl = '';
            let goods = {}
            if (this.functionIndex == 0) {
                funcName = '无'
            } else if (this.functionIndex == 1) {
                // { label: '1', name: '消息中心' },
                // { label: '2', name: '佣金管理' },
                // { label: '3', name: '地址管理' },
                // { label: '4', name: '银行卡' },
                // { label: '5', name: '店铺申请' }
                // if (this.functionInletRadio == '1') {
                //   funcName = '消息中心'
                // }
                // if (this.functionInletRadio == '2') {
                //   funcName = '佣金管理'
                // }
                // if (this.functionInletRadio == '3') {
                //   funcName = '地址管理'
                // }
                // if (this.functionInletRadio == '4') {
                //   funcName = '银行卡'
                // }
                // if (this.functionInletRadio == '5') {
                //   funcName = '店铺申请'
                // }
                // if (this.functionInletRadio == '6') {
                //   funcName = '粉丝管理'
                // }
                // if (this.functionInletRadio == '7') {
                //   funcName = '联系客服'
                // }
                // if (this.functionInletRadio == '8') {
                //   funcName = '会员中心'
                // }
                // if (this.functionInletRadio == '9') {
                //   funcName = '优惠券'
                // }
                // if (this.functionInletRadio == '10') {
                //   funcName = '订单中心'
                // }
                funcName = this.pageName;
                navUrl = this.navUrl;
            } else if (this.functionIndex == 2) {
                goodsSelectedId = this.goodsSelectedId;
                this.goodsList.forEach((item) => {
                    if (this.goodsSelectedId === item.itemNo) {
                        funcName = item.name.substring(0, 8) + '...'
                        goods = item
                    }
                })
                // funcName = this.pageName;
            } else if (this.functionIndex == 3) {
                this.pageList.forEach((item) => {
                    if (this.pageId === item.id) {
                        funcName = item.title || item.name
                    }
                })
            }
            if (this.viewData[this.viewIndex].modelType == 1) {//搜索框模块
                this.viewData[this.viewIndex].modelDetail.navModel.funcName = funcName;
                this.viewData[this.viewIndex].modelDetail.navModel.navUrl = navUrl;
                this.viewData[this.viewIndex].modelDetail.navModel.navType = this.functionIndex;
                this.viewData[this.viewIndex].modelDetail.navModel.rootCategoryId = rootCategoryId;
                this.viewData[this.viewIndex].modelDetail.navModel.categoryId = categoryId;
                this.viewData[this.viewIndex].modelDetail.navModel.goodsSelectedId = goodsSelectedId;
                this.viewData[this.viewIndex].modelDetail.navModel.functionInletRadio = this.functionInletRadio;
                this.viewData[this.viewIndex].modelDetail.navModel.labelId = this.labelId;
                this.viewData[this.viewIndex].modelDetail.navModel.pageId = this.pageId;
                this.viewData[this.viewIndex].modelDetail.navModel.pageType = this.pageType;
            }
            if (this.viewData[this.viewIndex].modelType == 2) {//轮播图模块
                this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.funcName = funcName;
                this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.navUrl = navUrl
                this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.navType = this.functionIndex;
                this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.rootCategoryId = rootCategoryId;
                this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.categoryId = categoryId;
                this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.goodsSelectedId = goodsSelectedId;
                this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.functionInletRadio = this.functionInletRadio;
                this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.labelId = this.labelId;
                this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.pageId = this.pageId;
                this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.pageType = this.pageType;
            }
            if (this.viewData[this.viewIndex].modelType == 3) {//分类导航模块categoryNavList
                console.log('rowIndex', this.rowIndex)
                this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.funcName = funcName;
                this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.navUrl = navUrl
                this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.navType = this.functionIndex;
                this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.rootCategoryId = rootCategoryId;
                this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.categoryId = categoryId;
                this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.goodsSelectedId = goodsSelectedId;
                this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.functionInletRadio = this.functionInletRadio;
                this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.labelId = this.labelId;
                this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.pageId = this.pageId;
                this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.pageType = this.pageType;
            }
            if (this.viewData[this.viewIndex].modelType == 4 || this.viewData[this.viewIndex].modelType == 11) {//图片导航模块
                console.log('rowIndex', this.rowIndex)
                this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.funcName = funcName;
                this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.navUrl = navUrl;
                this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.navType = this.functionIndex;
                this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.rootCategoryId = rootCategoryId;
                this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.categoryId = categoryId;
                this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.goodsSelectedId = goodsSelectedId;
                this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.functionInletRadio = this.functionInletRadio;
                this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.labelId = this.labelId;
                this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.pageId = this.pageId;
                this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.pageType = this.pageType;

            }
            if (this.viewData[this.viewIndex].modelType == 5) {//标题导航模块
                this.viewData[this.viewIndex].modelDetail.navModel.funcName = funcName;
                this.viewData[this.viewIndex].modelDetail.navModel.navUrl = navUrl;
                this.viewData[this.viewIndex].modelDetail.navModel.navType = this.functionIndex;
                this.viewData[this.viewIndex].modelDetail.navModel.rootCategoryId = rootCategoryId;
                this.viewData[this.viewIndex].modelDetail.navModel.categoryId = categoryId;
                this.viewData[this.viewIndex].modelDetail.navModel.goodsSelectedId = goodsSelectedId;
                this.viewData[this.viewIndex].modelDetail.navModel.functionInletRadio = this.functionInletRadio;
                this.viewData[this.viewIndex].modelDetail.navModel.labelId = this.labelId;
                this.viewData[this.viewIndex].modelDetail.navModel.pageId = this.pageId;
                this.viewData[this.viewIndex].modelDetail.navModel.pageType = this.pageType;
            }
            if (this.viewData[this.viewIndex].modelType == 6 || this.viewData[this.viewIndex].modelType == 8) {//活动导航模块
                if (this.activeRow.oneLan == 1) {
                    this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.funcName = funcName;
                    this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.navUrl = navUrl
                    this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.navType = this.functionIndex;
                    this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.rootCategoryId = rootCategoryId;
                    this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.categoryId = categoryId;
                    this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.goodsSelectedId = goodsSelectedId;
                    this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.functionInletRadio = this.functionInletRadio;
                    this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.labelId = this.labelId;
                    this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.pageId = this.pageId;
                    this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.pageType = this.pageType;
                } else {
                    console.log('this.activeRow.id==', this.activeRow, this.viewData[this.viewIndex].modelDetail.activityNavList)
                    let arr = this.viewData[this.viewIndex].modelDetail.activityNavList.filter(item => {
                        return item.children && item.children[this.activeRow.index].id == this.activeRow.id

                    })
                    console.log('arr==', arr)
                    arr[0].children[this.activeRow.index].navModel.funcName = funcName;
                    arr[0].children[this.activeRow.index].navModel.navUrl = navUrl;
                    arr[0].children[this.activeRow.index].navModel.navType = this.functionIndex;
                    arr[0].children[this.activeRow.index].navModel.rootCategoryId = rootCategoryId;
                    arr[0].children[this.activeRow.index].navModel.categoryId = categoryId;
                    arr[0].children[this.activeRow.index].navModel.goodsSelectedId = goodsSelectedId;
                    arr[0].children[this.activeRow.index].navModel.functionInletRadio = this.functionInletRadio;
                    arr[0].children[this.activeRow.index].navModel.labelId = this.labelId;
                    arr[0].children[this.activeRow.index].navModel.pageId = this.pageId;
                    arr[0].children[this.activeRow.index].navModel.pageType = this.pageType;
                }
            }
            if (this.viewData[this.viewIndex].modelType == 12) {//标题导航模块
                this.viewData[this.viewIndex].modelDetail.viewGoodsList[this.rowIndex].goods = goods
                this.viewData[this.viewIndex].modelDetail.viewGoodsList[this.rowIndex].navModel.funcName = funcName;
                this.viewData[this.viewIndex].modelDetail.viewGoodsList[this.rowIndex].navModel.goodsSelectedId = goodsSelectedId;
                this.viewData[this.viewIndex].modelDetail.idList = this.viewData[this.viewIndex].modelDetail.viewGoodsList.map(item => {
                    return item.goods.itemNo
                })
                let list = await this.getGoodsList(this.viewData[this.viewIndex].modelDetail.idList)
                this.$nextTick(() => {
                    this.viewData[this.viewIndex].modelDetail.goodsList = list
                    console.log(this.viewData)
                })
            }
            console.log('this.viewData[this.viewIndex].modelType == ', this.viewData[this.viewIndex].modelType, this.rowIndex)
            if (this.rowIndex == 'title') {
                // viewData.navType = 0; //1-功能跳转，2-分类标签，3-商品
                // viewData.funcName = '无';
                // viewData.navUrl = '';
                console.log('来了吗')
                this.viewData[this.viewIndex].navType = this.functionIndex;
                this.viewData[this.viewIndex].funcName = funcName;
                this.viewData[this.viewIndex].navUrl = navUrl;
                this.viewData[this.viewIndex].goodsSelectedId = goodsSelectedId;
                this.viewData[this.viewIndex].functionInletRadio = this.functionInletRadio
                this.modulData.navType = this.functionIndex;
                this.modulData.funcName = funcName;
                this.modulData.navUrl = navUrl;
                this.modulData.goodsSelectedId = goodsSelectedId;
                this.modulData.functionInletRadio = this.functionInletRadio
            }
            this.$forceUpdate()
            // console.log(this.viewData[this.viewIndex].modelDetail)
            this.dialogVisible = false;
            this.$nextTick(() => {
                this.rootCategoryId = null;
                this.categoryId = null;
                this.goodsSelectedId = null;
                this.functionInletRadio = null;
            })
        },
        showDialog(viewIndex, rowIndex, navType, goodsId) {
            this.viewIndex = viewIndex;
            if (this.viewData[this.viewIndex].modelType == 6 || this.viewData[this.viewIndex].modelType == 8) {
                this.activeRow = rowIndex;
            } else {
                this.rowIndex = rowIndex;
            }
            console.log('navType==', navType, rowIndex)
            console.log('pageId ======== ')
            this.dialogVisible = true;
            this.functionIndex = navType
            this.selectedGoods = []
            this.goodsSelectedId = goodsId
            if (navType == 1) {//功能入口
                if (this.viewData[this.viewIndex].modelType == 1) {//轮播图
                    this.functionInletRadio = this.viewData[this.viewIndex].modelDetail.navModel.functionInletRadio
                }
                if (this.viewData[this.viewIndex].modelType == 2) {//轮播图
                    this.functionInletRadio = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.functionInletRadio
                }
                if (this.viewData[this.viewIndex].modelType == 3) {//分类导航
                    this.functionInletRadio = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.functionInletRadio
                }
                if (this.viewData[this.viewIndex].modelType == 4 || this.viewData[this.viewIndex].modelType == 11) {//图片导航
                    this.functionInletRadio = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.functionInletRadio
                }
                if (this.viewData[this.viewIndex].modelType == 5) {//标题导航
                    this.functionInletRadio = this.viewData[this.viewIndex].modelDetail.navModel.functionInletRadio
                }
                if (this.viewData[this.viewIndex].modelType == 6 || this.viewData[this.viewIndex].modelType == 8) {//活动导航
                    console.log(this.viewData[this.viewIndex].modelDetail)
                    if (this.activeRow.oneLan == 1) {
                        this.functionInletRadio = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.functionInletRadio
                    } else {
                        let arr = this.viewData[this.viewIndex].modelDetail.activityNavList.filter(item => {
                            return item.children && item.children[this.activeRow.index].id == this.activeRow.id
                        })
                        console.log('arr==', arr)
                        this.functionInletRadio = arr[0].children[this.activeRow.index].navModel.functionInletRadio;
                    }

                }
                if (this.rowIndex == 'title') {
                    // viewData.navType = 0; //1-功能跳转，2-分类标签，3-商品
                    // viewData.funcName = '无';
                    // viewData.navUrl = '';
                    console.log('来了吗', this.viewData[this.viewIndex])
                    this.functionInletRadio = this.viewData[this.viewIndex].functionInletRadio || null;
                }

            }
            if (navType == 2) {//分类类目
                console.log(this.viewData[this.viewIndex])
                if (this.viewData[this.viewIndex].modelType == 1) {//搜索框
                    if (this.classifyType == '2') {
                        this.labelId = this.viewData[this.viewIndex].modelDetail.navModel.labelId || null;
                        return
                    }
                    this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.navModel.rootCategoryId
                    this.categoryId = this.viewData[this.viewIndex].modelDetail.navModel.categoryId

                }
                if (this.viewData[this.viewIndex].modelType == 2) {//轮播图
                    if (this.classifyType == '2') {
                        this.labelId = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.labelId || null;
                        return
                    }
                    this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.rootCategoryId
                    this.categoryId = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.categoryId

                }
                if (this.viewData[this.viewIndex].modelType == 3) {//分类导航
                    if (this.classifyType == '2') {
                        this.labelId = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.labelId || null;
                        return
                    }
                    this.categoryId = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.categoryId
                    this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.rootCategoryId

                }
                if (this.viewData[this.viewIndex].modelType == 4 || this.viewData[this.viewIndex].modelType == 11) {//图片导航
                    if (this.classifyType == '2') {
                        this.labelId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.labelId || null;
                        return
                    }
                    this.categoryId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.categoryId
                    this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.rootCategoryId

                }
                if (this.viewData[this.viewIndex].modelType == 5) {//标题导航
                    if (this.classifyType == '2') {
                        this.labelId = this.viewData[this.viewIndex].modelDetail.navModel.labelId || null;
                        return
                    }
                    this.categoryId = this.viewData[this.viewIndex].modelDetail.navModel.categoryId
                    this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.navModel.rootCategoryId
                }
                if (this.viewData[this.viewIndex].modelType == 6 || this.viewData[this.viewIndex].modelType == 8) {//活动导航
                    console.log('rowIndex==', rowIndex)
                    if (this.activeRow.oneLan == 1) {
                        console.log(this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1])
                        if (this.classifyType == '2') {
                            this.labelId = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.labelId || null;
                            return
                        }
                        this.categoryId = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.categoryId
                        this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.rootCategoryId
                        this.pageId = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.pageId || null;
                        this.pageType = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.pageType;
                    } else {
                        console.log('this.activeRow.id==', this.activeRow.id)
                        let arr = this.viewData[this.viewIndex].modelDetail.activityNavList.filter(item => {
                            return item.children && item.children[this.activeRow.index].id == this.activeRow.id
                        })

                        console.log('arr==', arr)
                        if (this.classifyType == '2') {
                            this.labelId = arr[0].children[this.activeRow.index].navModel.labelId || null;
                            return
                        }
                        this.categoryId = arr[0].children[this.activeRow.index].navModel.categoryId;
                        this.rootCategoryId = arr[0].children[this.activeRow.index].navModel.rootCategoryId
                        this.pageId = arr[0].children[this.activeRow.index].navModel.pageId || null;
                        this.pageType = arr[0].children[this.activeRow.index].navModel.pageType;
                    }
                    // if (this.viewData[this.viewIndex].modelDetail.activityNavList[rowIndex]) {
                    //   this.categoryId = this.viewData[this.viewIndex].modelDetail.activityNavList[rowIndex].navModel.categoryId
                    //   this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.activityNavList[rowIndex].navModel.rootCategoryId
                    // } else {
                    //   console.log('5555555', this.viewData[this.viewIndex].modelDetail.activityNavList[rowIndex - 1])
                    //   this.categoryId = this.viewData[this.viewIndex].modelDetail.activityNavList[rowIndex - 1].children[0].navModel.categoryId
                    //   this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.activityNavList[rowIndex - 1].children[0].navModel.rootCategoryId
                    // }

                }

                this.searchCate()
            }
            if (navType == 3) {
                if (this.viewData[this.viewIndex].modelType == 1) {//搜索框
                    this.pageId = this.viewData[this.viewIndex].modelDetail.navModel.pageId;
                    this.pageType = this.viewData[this.viewIndex].modelDetail.navModel.pageType;
                }
                if (this.viewData[this.viewIndex].modelType == 2) {//轮播图
                    this.pageId = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.pageId || null;
                    this.pageType = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.pageType || null;
                }
                if (this.viewData[this.viewIndex].modelType == 3) {//分类导航
                    this.pageId = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.pageId || null;
                    this.pageType = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.pageType || null;
                }
                if (this.viewData[this.viewIndex].modelType == 4 || this.viewData[this.viewIndex].modelType == 11) {//图片导航
                    this.pageId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.pageId || null;
                    this.pageType = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.pageType || null;
                    console.log('页面设置==', this.pageId, this.pageType)
                }
                if (this.viewData[this.viewIndex].modelType == 5) {//标题导航
                    this.pageId = this.viewData[this.viewIndex].modelDetail.navModel.pageId || null;
                    this.pageType = this.viewData[this.viewIndex].modelDetail.navModel.pageType || null;
                }
                if (this.viewData[this.viewIndex].modelType == 6 || this.viewData[this.viewIndex].modelType == 8) {//活动导航
                    if (this.activeRow.oneLan == 1) {
                        // alert(this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.pageType)
                        this.pageId = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.pageId || null;
                        this.pageType = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.pageType;
                    } else {
                        // alert(this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.pageType,44)
                        console.log('this.activeRow.id==', this.activeRow.id)
                        let arr = this.viewData[this.viewIndex].modelDetail.activityNavList.filter(item => {
                            return item.children && item.children[this.activeRow.index].id == this.activeRow.id
                        })

                        this.pageId = arr[0].children[this.activeRow.index].navModel.pageId || null;
                        this.pageType = arr[0].children[this.activeRow.index].navModel.pageType;
                    }
                    this.searchForm.pageNo = 1;
                    this.getPageList()
                }
                if (this.rowIndex == 'title') {
                    // viewData.navType = 0; //1-功能跳转，2-分类标签，3-商品
                    // viewData.funcName = '无';
                    // viewData.navUrl = '';
                    console.log('来了吗', this.viewData[this.viewIndex])
                    this.pageId = this.viewData[this.viewIndex].pageId || null;
                    this.pageType = this.viewData[this.viewIndex].pageType || 1;
                }
                console.log('this.viewData[this.viewIndex].modelDetail=== pageType', this.viewData[this.viewIndex].modelDetail)
                this.searchForm.pageNo = 1;
                this.getPageList()
            }

            this.goodsPageNo = 1
            // console.log(goodsId)
            let data = {
                pageNo: this.goodsPageNo,
                pageSize: this.goodsPageSize,
                selectedId: this.goodsSelectedId,
                goodsInfo: this.goodsInfo,
                goodsType: this.goodsType
            }
            this.axios.post('/goods/GoodsOrGiftPageListForSelect', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.goodsList = res.data.list;
                        this.goodsList.forEach((item) => {
                            if (goodsId === item.goodsId) {
                                this.getGoodsName(item.goodsName)
                            }
                        })
                    }
                })
            // this.goodsList.forEach((item) => {
            //   if (goodsId === item.goodsId) {
            //     this.getGoodsName(item.goodsName)
            //   }
            // })
            this.$forceUpdate()

        },
        getImage(e, type, index) {
            if (type == 'top') {
                this.navForm.topList[0].icon = e
                // this.navViewList = [...this.navForm.contentList]
                // let objT = {
                //     inx: '-1',
                //     icon: e,
                //     relative: this.navForm.topList[0].relative
                // }
                // if (this.navForm.topList[0].position == '1') {
                //     this.navViewList.unshift(objT)
                // } else {
                //     this.navViewList.push(objT)
                // }
            } else if (type == 'content') {
                this.navForm.contentList[index].icon = e
                // this.navViewList = [...this.navForm.contentList]
                // let objT = {
                //     inx: '-1',
                //     icon: this.navForm.topList[0].icon,
                //     relative: this.navForm.topList[0].relative
                // }
                // if (this.navForm.topList[0].position == '1') {
                //     this.navViewList.unshift(objT)
                // } else {
                //     this.navViewList.push(objT)
                // }
            }
            this.handleR()
            this.$forceUpdate()
        },
        getImageShow(e, type) {
            if (type == 'isShow') {
                this.navForm.showStyle = e
            } else {
                this.navForm.hideStyle = e
            }
        },
        getGoodsName(name) {
            console.log(name, '------------')
            if (name != undefined) {
                this.pageName = name.substring(0, 8) + '...'
            }
            // this.pageName = name.substring(0, 8) + '...'
        },
        swicthCate(id, name) {
            this.pageName = name;
        },
        swicthRootCate(id, name) {
            this.rootCategoryId = id;
            this.catePageNo = 1;
            this.getCategoryList()
        },
        handleSizeChangecate(e) {
            this.catePageSize = e;
            this.catePageNo = 1;
            this.getCategoryList()
        },
        handleCurrentChangecate(e) {
            this.catePageNo = e;
            this.getCategoryList()
        },
        //获取一级分类列表
        getRootCategoryList() {
            this.axios.get('/sys/index/getRootCategoryList?selectedId=' + this.rootCategoryId)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        let list = res.data;
                        let idx = list.findIndex(item => item.selected)
                        this.rootCategoryId = this.rootCategoryId ? this.rootCategoryId : list[0].id;
                        this.rootCategory = list;
                        this.getCategoryList()
                    }
                })
        },
        searchCate() {
            this.catePageNo = 1;
            this.getCategoryList()
        },
        //获取二级分类列个表
        getCategoryList() {
            let data = {
                pageNo: this.catePageNo,
                pageSize: this.catePageSize,
                parentId: this.rootCategoryId,
                selectedId: this.categoryId,
                categoryName: this.categoryName
            }
            this.axios.post('/sys/index/getCategoryList', data)
                .then(res => {
                    console.log('555', res)
                    let list = res.data.list;
                    let idx = list.findIndex(item => item.selected)
                    if (idx > -1) {
                        this.categoryId = list[idx].id;
                    }
                    this.category = list;
                    this.cateTotalNum = res.data.totalNum;
                    console.log(this.category)
                })
        },
        handleSizeChange(e) {
            this.goodsPageNo = 1;
            this.goodsPageSize = e;
            this.getGoodsPage()
        },
        handleCurrentChange(e) {
            this.goodsPageNo = e;
            this.getGoodsPage()
        },
        handleSizeChange1(e) {
            this.goodsPageNo1 = 1;
            this.goodsPageSize1 = e;
            this.getGoodsPage1()
        },
        handleCurrentChange1(e) {
            this.goodsPageNo1 = e;
            this.getGoodsPage1()
        },
        searchGoods1() {
            this.goodsPageNo1 = 1;
            this.getGoodsPage1()
        },
        //获取商品列表
        getGoodsPage1() {
            let data = {
                pageNo: this.goodsPageNo1,
                pageSize: this.goodsPageSize1,
                name: this.goodsInfo1,
                goodsType: this.goodsType1,
                id: this.activityId
            }
            this.axios.post('/marketActivate/goodsPageList', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.goodsList1 = res.data.list;
                        this.goodsTotalNum1 = res.data.totalNum;
                        let list = []
                        //遍历表格的数据，再遍历需要在表格中反显的数据，两者的id一致
                        if (this.viewData.length == 0) {
                            return
                        }
                        console.log(this.viewData[this.viewIndex].modelDetail)
                        if (this.viewData[this.viewIndex].modelDetail && this.viewData[this.viewIndex].modelDetail.goodsList) {
                            this.goodsList1.forEach((item) => {
                                this.viewData[this.viewIndex].modelDetail.goodsList.forEach(val => {
                                    if (val.goodsId === item.goodsId) {
                                        // 把判断出来的默认表格数据push到创建的数组中
                                        list.push(item)
                                    }
                                })
                            })
                            console.log('选中的数组', list)
                            if (list.length > 0) {
                                //再遍历数组，将数据放入方法中
                                this.$nextTick(() => {
                                    list.forEach((row) => {
                                        this.$refs.goodsTable1.toggleRowSelection(row)
                                    })
                                })

                            }
                        }

                    }
                })
        },
        searchGoods() {
            this.goodsPageNo = 1;
            this.getGoodsPage()
        },
        //获取商品列表
        getGoodsPage() {
            let data = {
                pageNo: this.goodsPageNo,
                pageSize: this.goodsPageSize,
                selectedId: '',
                goodsInfo: this.goodsInfo,
                goodsType: this.goodsType
            }
            this.axios.post('/goods/GoodsOrGiftPageListForSelect', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.goodsList = res.data.list;
                        this.goodsTotalNum = res.data.totalNum;
                        let list = []
                        //遍历表格的数据，再遍历需要在表格中反显的数据，两者的id一致
                        if (this.viewData.length == 0) {
                            return
                        }
                        console.log(this.viewData[this.viewIndex].modelDetail)
                        if (this.viewData[this.viewIndex].modelDetail && this.viewData[this.viewIndex].modelDetail.goodsList) {
                            this.goodsList.forEach((item) => {
                                this.viewData[this.viewIndex].modelDetail.goodsList.forEach(val => {
                                    if (val.goodsId === item.goodsId) {
                                        // 把判断出来的默认表格数据push到创建的数组中
                                        list.push(item)
                                    }
                                })
                            })
                            console.log('选中的数组', list)
                            if (list.length > 0) {
                                //再遍历数组，将数据放入方法中
                                this.$nextTick(() => {
                                    list.forEach((row) => {
                                        this.$refs.goodsTable.toggleRowSelection(row)
                                    })
                                })

                            }
                        }

                    }
                })
        },
        // 获取首页数据
        getIndexTemplate() {
            let data = {
                type: '1',
                activityId: this.activityId
            }
            this.axios.post('/indexTemplate/get', data)
                .then(res => {
                    console.log(res)
                    if (res.code === 0) {
                        this.pid = res.data.id;
                        let modelJson = []
                        if (res.data.modelJsonStr != null) {
                            modelJson = JSON.parse(res.data.modelJsonStr)
                        }

                        modelJson.forEach(async item => {
                            if (item.modelType == 1) {
                                let navModel = {
                                    navType: 0, //1-功能跳转，2-分类标签，3-商品
                                    funcName: '无',
                                    navUrl: '',
                                    id: null //功能、分类或商品id
                                }
                                if (!item.modelDetail.navName) {
                                    let data = {
                                        navName: '',
                                        navModel: navModel
                                    }
                                    item.modelDetail = data
                                }
                            }
                            if (item.modelType == 7) {
                                console.log('商品模块', item.modelDetail)
                                if (item.modelDetail.idList && item.modelDetail.idList.length > 0) {
                                    let goodsList = await this.getGoodsList(item.modelDetail.idList)
                                    console.log('这是商品', goodsList)
                                    item.modelDetail.viewGoodsList = goodsList;
                                    item.modelDetail.idList = goodsList.map(i => {
                                        return i.itemNo
                                    })
                                }
                                if (item.modelDetail.goodsType == 2) {
                                    let tagIds = item.modelDetail.tagList.map(i => {
                                        return i.id
                                    })
                                    item.modelDetail.tagList = await this.getEnableTags(tagIds)
                                    item.modelDetail.tagList.forEach((t, i) => {
                                        this.goodsTagList.forEach((g, d) => {
                                            if (t.id == g.id) {
                                                g.selected = true
                                            }
                                        })
                                    })
                                    console.log('标签-==', this.goodsTagList)
                                    // setTimeout(()=>{

                                    // },2000)

                                }
                            }
                            if (item.modelType == 12) {
                                let list = await this.getGoodsList1(item.modelDetail.idList)
                                this.$nextTick(() => {
                                    item.modelDetail.goodsList = list
                                    console.log(this.viewData)
                                })
                            }
                            if (item.modelType == 10) {
                                console.log('商品模块', item.modelDetail)
                                if (item.modelDetail.goodsList && item.modelDetail.goodsList.length > 0) {
                                    item.modelDetail.idList = item.modelDetail.goodsList.map(i => {
                                        return i.goodsNo
                                    })
                                    let goodsList = await this.getGoodsList1(item.modelDetail.idList)
                                    console.log('这是商品', goodsList)
                                    goodsList.forEach(item => {
                                        item.discount = Number((item.price / item.marketPrice) * 10).toFixed(2)
                                    })
                                    item.modelDetail.viewGoodsList = goodsList;
                                    // item.modelDetail.idList = goodsList.map(i => {
                                    //     return i.goodsOrGiftNo
                                    // })
                                }
                                if (item.modelDetail.goodsType == 2) {
                                    let tagIds = item.modelDetail.tagList.map(i => {
                                        return i.id
                                    })
                                    item.modelDetail.tagList = await this.getEnableTags(tagIds)
                                    item.modelDetail.tagList.forEach((t, i) => {
                                        this.goodsTagList.forEach((g, d) => {
                                            if (t.id == g.id) {
                                                g.selected = true
                                            }
                                        })
                                    })
                                    console.log('标签-==', this.goodsTagList)
                                    // setTimeout(()=>{

                                    // },2000)

                                }
                            }
                            if (item.modelType == 2) {
                                item.height = item.height ? item.height : '';
                                item.radioHeight = item.radioHeight ? item.radioHeight : '1'
                            }
                            if (item.modelType == 6 || item.modelType == 8) {
                                // item.activeName
                                console.log('活动===', item)
                                item.modelDetail.activityNavList.forEach(acItem => {
                                    acItem.navModel.activeName = acItem.navModel.activeName ? acItem.navModel.activeName : '';
                                    if (acItem.children && acItem.children.length > 0) {
                                        acItem.children.forEach(chil => {
                                            chil.navModel.activeName = chil.navModel.activeName ? chil.navModel.activeName : '';
                                        })
                                    }
                                })
                            }
                            item.margin = item.margin ? item.margin : ''

                        })
                        this.viewData = modelJson;
                        let data1 = {
                            type: '3',
                            activityId: this.activityId
                        }
                        this.axios.post('/indexTemplate/get', data1)
                            .then(res1 => {
                                if (res1.code == 0) {
                                    let modelJson1 = {}
                                    if (res1.data.modelJsonStr != null) {
                                        modelJson1 = JSON.parse(res1.data.modelJsonStr)
                                    } else {
                                        modelJson1 = {
                                            showStyle: '',
                                            hideStyle: '',
                                            margin: '',
                                            navIndex: '',
                                            position: '1',
                                            isShow: '0',
                                            topList: [
                                                {
                                                    position: '1',
                                                    icon: '',
                                                    relative: true
                                                }
                                            ],
                                            contentList: [

                                            ]
                                        }
                                    }
                                    console.log('7777', modelJson1)
                                    this.navForm = modelJson1;
                                    // this.navForm.topList = []
                                    // let obj = {
                                    //     position: '1',
                                    //     icon: '',
                                    //     relative: true
                                    // }
                                    // this.navForm.topList.push(obj)

                                    if (this.navForm.contentList.length == 0) {
                                        this.navForm.contentList = []
                                        this.viewData.forEach((item, index) => {
                                            let inx = 0
                                            if (index + 1 <= 9) {
                                                inx = '0' + (index + 1)
                                            } else {
                                                inx = index + 1
                                            }
                                            let obj = {
                                                inx: inx,
                                                icon: '',
                                                relative: true
                                            }
                                            this.navForm.contentList.push(obj)
                                        })

                                    } else {
                                        let arr = []
                                        this.viewData.forEach((item, index) => {
                                            item.inx = 0
                                            if (index + 1 <= 9) {
                                                item.inx = '0' + (index + 1)
                                            } else {
                                                item.inx = index + 1
                                            }
                                            this.navForm.contentList.forEach(itm => {
                                                if (itm.inx == item.inx) {
                                                    item.icon = itm.icon
                                                    item.relative = itm.relative
                                                }

                                            })
                                            let obj = {
                                                inx: item.inx,
                                                icon: item.icon,
                                                relative: item.relative
                                            }
                                            arr.push(obj)
                                        })
                                        this.navForm.contentList = arr
                                    }
                                    console.log(this.navForm.contentList, '999999999')
                                    let viewArr = []
                                    viewArr = [...this.navForm.contentList]
                                    let objT = {
                                        inx: '-1',
                                        icon: this.navForm.topList[0].icon || '',
                                        relative: this.navForm.topList[0].relative
                                    }
                                    if (this.navForm.topList[0].position == '1') {

                                        viewArr.unshift(objT)
                                    } else {
                                        viewArr.push(objT)
                                    }
                                    this.navViewList = viewArr.filter(item => { return item.relative == 1 })
                                    this.isIcon = this.navViewList.every(item => item.icon != '')
                                    if (this.navForm.navIndex) {
                                        this.isInViewport('refScroll' + Number(this.navForm.navIndex - 1))
                                    }

                                }
                            })



                        console.log(this.isView)
                        console.log(this.navViewList)
                        this.$forceUpdate()
                        console.log(modelJson)
                    }
                })
        },
        async getEnableTags(ids) {
            let res = await this.axios.get('/appIndex/getEnableTags?tagIds=' + ids)
            console.log('过滤标签==', res)
            if (res.code == 0) {
                return res.data
            } else {
                return []
            }
        },
        //根据id获取商品
        async getGoodsList(ids) {
            let res = await this.axios.post('/goods/findGoodsByGoodsNos', { goodsNos: ids, activityId: this.activityId })
            console.log(res)
            if (res.code == 0) {
                return res.data
            }
        },
        //根据id获取商品
        async getGoodsList1(ids) {
            let res = await this.axios.post('/tagPool/activateGoods/list', { goodsNos: ids, activateId: this.activityId })
            console.log(res)
            if (res.code == 0) {
                res.data.list.forEach(item => {
                    item.discount = Number((item.price / item.marketPrice) * 10).toFixed(2)
                })
                return res.data.list
            }
        },
        //节日送礼节日选择
        getDateChange(e, viewIndex, idx) {
            console.log(e)
            let list = this.viewData[viewIndex].modelDetail.imgList;
            let date1 = new Date(e)
            let date2 = new Date()
            const diffTime = Math.abs(date1 - date2);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            list[idx].days = diffDays
            console.log(diffDays)
        },
        //表格操作
        async toTableDown(viewIndex, idx) {
            console.log(this.viewData[viewIndex].modelDetail)
            let array = []
            if (this.viewData[viewIndex].modelType == 2) {
                array = this.viewData[viewIndex].modelDetail.swiperImageList;
            }
            if (this.viewData[viewIndex].modelType == 3) {
                array = this.viewData[viewIndex].modelDetail.categoryNavList;
            }
            if (this.viewData[viewIndex].modelType == 4) {
                array = this.viewData[viewIndex].modelDetail.imgList;
            }
            if (this.viewData[viewIndex].modelType == 6 || this.viewData[viewIndex].modelType == 8) {
                idx = idx - 1;
                array = this.viewData[viewIndex].modelDetail.activityNavList;
            }
            if (this.viewData[viewIndex].modelType == 7 || this.viewData[viewIndex].modelType == 10) {
                array = this.viewData[viewIndex].modelDetail.goodsList;
            }

            if (this.viewData[viewIndex].modelType == 9) {
                array = this.viewData[viewIndex].modelDetail.couponsList;
            }
            if (this.viewData[viewIndex].modelType == 12) {
                array = this.viewData[viewIndex].modelDetail.viewGoodsList;
            }
            array.splice(idx + 1, 1, ...array.splice(idx, 1, array[idx + 1]));
            if (this.viewData[viewIndex].modelType == 6 || this.viewData[viewIndex].modelType == 8) {
                array[idx].id = array[idx].id - 1;
                array[idx + 1].id = array[idx + 1].id + 1
            }
            if (this.viewData[viewIndex].modelType == 7) {
                this.viewData[viewIndex].modelDetail.idList = this.viewData[viewIndex].modelDetail.goodsList.map(item => {
                    return item.itemNo
                })
            }
            if (this.viewData[viewIndex].modelType == 12) {
                this.viewData[viewIndex].modelDetail.idList = this.viewData[viewIndex].modelDetail.viewGoodsList.map(item => {
                    return item.goods.itemNo
                })
                let list = await this.getGoodsList(this.viewData[this.viewIndex].modelDetail.idList)
                this.$nextTick(() => {
                    this.viewData[viewIndex].modelDetail.goodsList = list
                    console.log(this.viewData)
                })
            }
            console.log(this.viewData[viewIndex].modelType)
            // this.viewData[viewIndex] = JSON.parse(JSON.stringify(this.viewData[viewIndex]))
            // this.$forceUpdate()

        },
        async toTabelUp(viewIndex, idx) {
            let array = []
            if (this.viewData[viewIndex].modelType == 2) {
                array = this.viewData[viewIndex].modelDetail.swiperImageList;
            }
            if (this.viewData[viewIndex].modelType == 3) {
                array = this.viewData[viewIndex].modelDetail.categoryNavList;
            }
            if (this.viewData[viewIndex].modelType == 4) {
                array = this.viewData[viewIndex].modelDetail.imgList;
            }
            if (this.viewData[viewIndex].modelType == 6 || this.viewData[viewIndex].modelType == 8) {
                idx = idx - 1;
                array = this.viewData[viewIndex].modelDetail.activityNavList;
            }
            if (this.viewData[viewIndex].modelType == 7 || this.viewData[viewIndex].modelType == 10) {
                array = this.viewData[viewIndex].modelDetail.goodsList;
            }
            if (this.viewData[viewIndex].modelType == 9) {
                array = this.viewData[viewIndex].modelDetail.couponsList;
            }
            if (this.viewData[viewIndex].modelType == 12) {
                array = this.viewData[viewIndex].modelDetail.viewGoodsList;
            }
            array.splice(idx, 1, ...array.splice(idx - 1, 1, array[idx]));
            if (this.viewData[viewIndex].modelType == 6) {
                array[idx].id = array[idx].id + 1;
                array[idx - 1].id = array[idx - 1].id - 1
            }
            if (this.viewData[viewIndex].modelType == 7) {
                this.viewData[viewIndex].modelDetail.idList = this.viewData[viewIndex].modelDetail.goodsList.map(item => {
                    return item.itemNo
                })
            }
            if (this.viewData[viewIndex].modelType == 12) {
                this.viewData[viewIndex].modelDetail.idList = this.viewData[viewIndex].modelDetail.viewGoodsList.map(item => {
                    return item.goods.itemNo
                })
                let list = await this.getGoodsList(this.viewData[this.viewIndex].modelDetail.idList)
                this.$nextTick(() => {
                    this.viewData[viewIndex].modelDetail.goodsList = list
                    console.log(this.viewData)
                })
            }

        },
        tableDel(viewIndex, idx, row, index) {
            let array = []
            if (this.viewData[viewIndex].modelType == 2) {
                array = this.viewData[viewIndex].modelDetail.swiperImageList;
            }
            if (this.viewData[viewIndex].modelType == 3) {
                array = this.viewData[viewIndex].modelDetail.categoryNavList;
            }
            if (this.viewData[viewIndex].modelType == 4 || this.viewData[this.viewIndex].modelType == 11) {
                array = this.viewData[viewIndex].modelDetail.imgList;
            }
            if (this.viewData[viewIndex].modelType == 6 || this.viewData[viewIndex].modelType == 8) {
                console.log('index=====', index)
                // if (children) {
                idx = idx - 1;
                // }

                array = this.viewData[viewIndex].modelDetail.activityNavList;
            }
            if (this.viewData[viewIndex].modelType == 7 || this.viewData[viewIndex].modelType == 10 || this.viewData[viewIndex].modelType == 12) {
                array = this.viewData[viewIndex].modelDetail.goodsList;
            }
            if (this.viewData[viewIndex].modelType == 9) {
                array = this.viewData[viewIndex].modelDetail.couponsList;
            }
            this.$confirm('是否确认删除？删除后不可恢复数据！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                if (this.viewData[viewIndex].modelType == 6 || this.viewData[viewIndex].modelType == 8) {
                    console.log(row)
                    if (row.oneLan == 1) {
                        console.log('大是大非看', array)
                        array.splice(idx, 1)
                    } else {
                        console.log(444, '===', idx)
                        // return
                        // if(this.viewData[viewIndex].modelDetail.activityNavList)
                        let arr = this.viewData[viewIndex].modelDetail.activityNavList.filter(item => {
                            return item.children && item.children[row.index].id == row.id
                        })
                        console.log(arr)
                        // return

                        if (row.index == 0) {
                            if (arr[0].children.length == 1) {
                                delete arr[0].children
                                arr[0].showType = 5;
                            } else {
                                arr[0].children.splice(0, 1)
                                arr[0].showType = 2;
                            }

                        } else {
                            arr[0].children.splice(1, 1)
                            arr[0].showType = 2;
                        }
                        if (arr[0].children && arr[0].children.length > 0) {
                            arr[0].children[0].index = 0
                        }

                    }
                    // if(!children){
                    //     console.log(34444)

                    // }else{


                    // }

                    // console.log('children',children,idx)
                    this.viewData[viewIndex].modelDetail.activityNavList.forEach((item, index) => {
                        item.id = index + 1;
                        if (item.children) {
                            item.children.forEach((itemx, indexx) => {
                                if (indexx == 0) {
                                    itemx.id = item.id + 10
                                } else {
                                    itemx.id = item.id + 110
                                }

                            })
                        }
                    })
                    this.viewData[viewIndex].modelDetail.activityNavList = JSON.parse(JSON.stringify(this.viewData[viewIndex].modelDetail.activityNavList))
                    console.log(this.viewData[viewIndex].modelDetail.activityNavList)
                    return
                }
                if (!(this.viewData[viewIndex].modelType == 6 || this.viewData[viewIndex].modelType == 8)) {
                    console.log(777777777)
                    array.splice(idx, 1)
                }
                if (this.viewData[viewIndex].modelType == 7) {
                    this.viewData[viewIndex].modelDetail.idList = this.viewData[viewIndex].modelDetail.goodsList.map(item => {
                        return item.itemNo
                    })
                    let list = await this.getGoodsList(this.viewData[this.viewIndex].modelDetail.idList)
                    this.$nextTick(() => {
                        this.viewData[this.viewIndex].modelDetail.viewGoodsList = list
                        console.log(this.viewData)
                    })
                }
                if (this.viewData[viewIndex].modelType == 10) {
                    this.viewData[viewIndex].modelDetail.idList = this.viewData[viewIndex].modelDetail.goodsList.map(item => {
                        return item.goodsNo
                    })
                    let list = await this.getGoodsList(this.viewData[this.viewIndex].modelDetail.idList)
                    this.$nextTick(() => {
                        this.viewData[this.viewIndex].modelDetail.viewGoodsList = list
                        console.log(this.viewData)
                    })

                }
                if (this.viewData[viewIndex].modelType == 12) {
                    this.viewData[viewIndex].modelDetail.idList = this.viewData[viewIndex].modelDetail.viewGoodsList.map(item => {
                        return item.goods.itemNo
                    })
                    let list = await this.getGoodsList1(this.viewData[this.viewIndex].modelDetail.idList)
                    this.$nextTick(() => {
                        this.viewData[viewIndex].modelDetail.goodsList = list
                        console.log(this.viewData)
                    })
                }
                this.$forceUpdate()
            }).catch(() => {

            });

        },
        // 模块操作条
        toDown(idx) {
            let array = this.viewData;
            array.splice(idx + 1, 1, ...array.splice(idx, 1, array[idx + 1]));
            setTimeout(() => {
                this.viewIndex = idx + 1;
                this.toggleBar(idx + 1)
            }, 200)

        },
        toUp(idx) {
            let array = this.viewData;
            array.splice(idx, 1, ...array.splice(idx - 1, 1, array[idx]));
            setTimeout(() => {
                this.viewIndex = idx - 1;
                this.toggleBar(idx - 1)
            }, 200)

        },
        toEdit(idx) {
            this.viewIndex = idx;
        },
        toDel(idx) {
            console.log(idx)
            this.delDialogVisible = true;
            this.delIndex = idx;
        },
        deleteViewFn() {
            this.viewData.splice(this.delIndex, 1)
            if (this.delIndex > 0) {
                this.viewIndex = this.delIndex - 1;
            } else {
                this.viewIndex = 0
            }

            console.log(this.viewData)
            this.delDialogVisible = false;
            this.$forceUpdate()
        },
        //鼠标点击模块
        handleView(idx) {
            this.viewIndex = idx;
            console.log(this.viewData[idx])
            if (this.viewData[idx].modelType == 6 || this.viewData[idx].modelType == 8) {
                setTimeout(() => {
                    this.expendAll = true
                }, 500)
            } else {
                this.expendAll = false
            }
            this.toggleBar(idx)
            this.$forceUpdate()
        },
        toggleBar(idx) {
            this.viewData.forEach((item, index) => {
                if (index == idx) {
                    item.showBar1 = true;
                    item.showBar2 = true;
                } else {
                    item.showBar1 = false;
                    item.showBar2 = false;
                }
            })
            this.$forceUpdate()
        },
        //鼠标经过事件
        handleCloseBar(e, idx) {
            // console.log(e, idx)
            this.viewData.forEach((item, index) => {
                if (index == idx) {
                    item.showBar1 = false;
                    item.showBar2 = false;
                }
            })
        },
        handleShowBar(e, idx) {
            console.log(e, idx, '2222222222')
            console.log(this.viewData)
            this.viewData.forEach((item, index) => {
                if (index == idx) {
                    console.log(4444)
                    item.showBar1 = true;
                    item.showBar2 = true
                } else {
                    item.showBar1 = false;
                    item.showBar2 = false
                }
            })
            console.log(this.viewData)
            this.$forceUpdate()
        },
        //点击添加功能模块
        addModul(idx) {
            //添加模块功能，先添加modelType确定模块类型，再根据模块类型添加相应的字段
            //1-搜索功能，2-轮播图，3-分类导航，4-图片导航，5-标题导航，6-活动导航，7-商品导航
            this.viewData.forEach(item => {
                item.showBar1 = false;
                item.showBar2 = false;
            })
            let modelType = idx + 1;
            let viewData = {
                modelType: modelType,
                showBar1: true,
                showBar2: true,
                modelOrder: this.viewData.length + 1,//模块排序
                modelDetail: {}, //模块详情
                layoutType: '1',//节日送礼排版 1-横版 2-竖版
                margin: '',
                goodsSelectedId: ''
            }
            let navModel = {
                navType: 0, //1-功能跳转，2-分类标签，3-商品
                funcName: '无',
                navUrl: '',
                pageType: 1,
                id: null //功能、分类或商品id
            }
            if (modelType == 1) {//搜索
                return
                let data = {
                    navName: '',
                    navModel: navModel
                }
                viewData.modelDetail = data
            } else if (modelType == 2) {//轮播图
                let data = {
                    imgName: '',
                    imgUrl: '',
                    navModel: navModel
                }
                viewData.radioHeight = '1';
                viewData.height = '';
                viewData.modelDetail.swiperImageList = [data]
            } else if (modelType == 3) {//分类导航
                let data = {
                    imgUrl: '',
                    categoryNavName: '',
                    navModel: navModel
                }
                let data2 = JSON.parse(JSON.stringify(data));
                viewData.modelDetail.categoryNavList = [data, data2]
                // setTimeout(()=>{viewData.modelDetail.categoryNavList.push(data)},200)

            } else if (modelType == 4 || modelType == 11) {// 图片导航
                let data = {
                    imgUrl: '',
                    navModel: navModel
                }
                viewData.modelDetail.imgList = [data]
            } else if (modelType == 5) {//标题导航
                let data = {
                    mainTitle: '',
                    subTitle: '',
                    showType: 1, //1-居左，2-居中
                    navModel: navModel
                }
                viewData.modelDetail = data
            } else if (modelType == 6) { //秒杀导航
                navModel.activeName = ''
                navModel.activeSubName = ''
                let data = {
                    id: 1,
                    showType: 5,// 5-一栏，2-两栏
                    oneLan: 1,
                    imgUrl: '',
                    navModel: navModel
                }
                viewData.modelDetail.activityNavList = [data]
            } else if (modelType == 7) {//商品导航
                let data = {
                    goodsType: 2,
                    idList: [],
                    goodsList: [],
                    viewGoodsList: [],
                    tagList: [],
                    tagGoodsList: []
                }
                viewData.modelDetail = data
            } else if (modelType == 8) { //活动导航
                navModel.activeName = ''
                navModel.activeSubName = ''
                let data = {
                    id: 1,
                    showType: 5,// 5-一栏，2-两栏
                    oneLan: 1,
                    imgUrl: '',
                    navModel: navModel
                }
                viewData.modelDetail.activityNavList = [data]
            } else if (modelType == 9) { //优惠券导航
                this.getCoupons()
                let data = {
                    id: '',
                    imgUrl: '',
                    imgUrl1: '',
                    imgUrl2: '',
                    // navModel: navModel
                }
                viewData.height = '';
                viewData.modelDetail.couponsList = [data]
            } else if (modelType == 10) {//活动商品导航
                if (this.activityType == 'add') {
                    this.$message.error('请添加活动商品后，再设置商品导航')
                    return
                } else {
                    let dataG = {
                        pageNo: this.goodsPageNo1,
                        pageSize: this.goodsPageSize1,
                        name: this.goodsInfo1,
                        goodsType: this.goodsType1,
                        id: this.activityId
                    }
                    this.axios.post('/marketActivate/goodsPageList', dataG)
                        .then(res => {
                            console.log(res)
                            if (res.code == 0) {
                                if (res.data.totalNum == 0) {
                                    this.$message.error('请添加活动商品后，再设置商品导航')
                                    return
                                }

                            }
                        })
                }
                let data = {
                    goodsType: 1,
                    idList: [],
                    goodsList: [],
                    viewGoodsList: [],
                    tagList: [],
                    tagGoodsList: []
                }
                viewData.modelDetail = data
            } else if (modelType == 12) {//商品排行榜
                let data = {
                    goodsType: 1,
                    idList: [],
                    goodsList: [
                        {
                            mainImage: '',
                            name: '',
                            price: '100.00',
                            discount: '0.75',
                            saleNum: 100
                        }
                    ],
                    viewGoodsList: [
                        {
                            goods: {},
                            navModel: navModel
                        }
                    ],

                }
                viewData.modelDetail = data
            }
            this.viewData.push(viewData)
            console.log(this.viewData)
            this.viewIndex = this.viewData.length - 1;
        },
        selectFunction(idx) {
            this.functionIndex = idx;
        },
        handleClose(e) {

        },
        toPage() {
            this.$router.push('./mallRenovation')
        }


    }


}
</script>
<style lang="scss" scoped>
.image-info {
    width: 396px;
    height: 38px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #909099;
    line-height: 19px;
    margin-left: 7px;
    margin-top: 13px;
}

::v-deep .el-switch__core {
    width: 50px !important;
}

.couponItem {
    width: 260px;
    height: 80px;
    background: url('https://fenxiao.muruji.com/internalSystem/df7f0310-681d-45ea-89b6-a1fba9f4dc63');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-radius: 16px;
    margin-right: 10px;
    flex-shrink: 0;

    .name {
        width: 140px;
        height: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 10px;
        color: #673000;
        line-height: 14px;
        margin-left: 10px;
        margin-top: 10px;
    }

    .c-price {
        min-width: 87px;
        max-width: 140px;
        height: 20px;
        font-family: PingFang SC;
        font-weight: bold;
        font-size: 14px;
        color: #673000;
        line-height: 20px;
        margin-left: 10px;
        margin-top: 5px;
    }

    .time {
        min-width: 104px;
        max-width: 140px;
        height: 11px;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 8px;
        color: #673000;
        line-height: 11px;
        margin-left: 10px;
        margin-top: 5px;
    }
}

input[type="text"],
input[type="number"] {
    -webkit-appearance: none;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #d8dce5;
    box-sizing: border-box;
    color: #5a5e66;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 1;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    width: 100%;

    &:hover {
        border-color: #b4bccc;
    }

    &:focus {
        border-color: #409EFF;
        outline: 0;
    }
}

.goodFirst {
    overflow-x: auto;
    width: 100%;
    // padding-left: 13px;
    // padding-right: 13px;
    box-sizing: border-box;

    .g-discount {
        width: 40px;
        height: 16px;
        background: linear-gradient(132deg, #2BDC9B 0%, #29B5E1 100%);
        border-radius: 2px 2px 2px 2px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 11px;
        color: #FFFFFF;
        line-height: 16px;
        text-align: center;
    }

    .g-sale {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 11px;
        color: #999999;
        line-height: 16px;
    }
}

.pr {
    width: 100%;
    min-height: 20px;
    position: relative;
    padding: 0 16px;
    box-sizing: border-box;
    cursor: move;
}

.prU {
    width: 100%;
    min-height: 20px;
    position: relative;
    padding: 0 0;
    box-sizing: border-box;
    cursor: move;
}

.pr1 {
    width: 100%;
    min-height: 20px;
    position: relative;
    // padding: 0 16px;
    box-sizing: border-box;
    cursor: move;
}

.bread-small {
    font-size: 16px;
}

.bread-active {
    color: black;
    border-bottom: 2px solid #2d46ee;
}

.page-content {
    width: 100%;
    display: flex;
    margin-top: 20px;
}

.phone-view {
    width: 375px;
    height: 667px;
    background: #fff;
    border-radius: 16px;
    margin-right: 56px;
    position: relative;
    background-image: url('https://fenxiao.muruji.com/internalSystem/66b20472-c0d9-4acb-bbb8-e292c93b5ded');
    background-size: contain;
    background-repeat: no-repeat;
}

.phone-viewU {
    width: 375px;
    height: 667px;
    background: #fff;
    border-radius: 16px;
    margin-right: 56px;
    position: relative;
}

.y-tag {
    width: 32px;
    height: 56px;
    background: #13CE4B;
    border-radius: 0px 3px 3px 0px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 20px;
    box-sizing: border-box;
    padding: 9px 9px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
}

.w-tag {
    width: 32px;
    height: 56px;
    background: #F63C56;
    border-radius: 0px 3px 3px 0px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 20px;
    box-sizing: border-box;
    padding: 9px 9px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
}

.phone-scroll {
    width: 100%;
    height: calc(100% - 88px);
    background-color: transparent;
    margin-top: 85px;
    overflow-y: auto;
    padding-top: 20px;
    box-sizing: border-box;

    .nav {
        min-width: 88px;
        height: calc(100% - 88px);
        z-index: 12;
        position: absolute;
        top: 88px;
        right: 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        overflow-y: auto;
        // margin-top: 85px;

        .isShow {
            width: 44px;
            height: 44px;
            background: rgba(0, 0, 0, 0.3);
            border-radius: 36px 0px 0px 36px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            .isShowText {
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 12px;
                color: #FFFFFF;
                line-height: 44px;
                margin-left: 4px;
            }
        }

        .nav-content {
            min-width: 44px;
            max-height: 100%;
            // min-height: 192px;
            background: #FFFFFF;
            box-shadow: 0px 3px 16px 1px rgba(0, 0, 0, 0.16);
            border-radius: 12px 0px 0px 12px;

            // 
            .nav-item {
                width: 44px;
                height: 44px;
                background: white;
                border-radius: 0px 0px 0px 0px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 13px;
                color: #333333;
                line-height: 44px;
                text-align: center;
                cursor: pointer;
            }

            .nav-item-active {
                width: 44px;
                height: 44px;
                background: #17CC8A;
                border-radius: 0px 0px 0px 0px;
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 13px;
                color: #FFFFFF;
                line-height: 44px;
                text-align: center;
                cursor: pointer;
            }
        }

    }

    .nav-left {
        width: 88px;
        height: calc(100% - 88px);
        z-index: 12;
        position: absolute;
        top: 88px;
        left: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        overflow-y: auto;

        .isShow {
            width: 44px;
            height: 44px;
            background: rgba(0, 0, 0, 0.3);
            border-radius: 0px 36px 36px 0px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            .isShowText {
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 12px;
                color: #FFFFFF;
                line-height: 44px;
                margin-left: 4px;
            }
        }

        .nav-content {
            min-width: 44px;
            max-height: 100%;
            // min-height: 192px;
            background: #FFFFFF;
            box-shadow: 0px 3px 16px 1px rgba(0, 0, 0, 0.16);
            border-radius: 0px 12px 12px 0px;



            .nav-item {
                width: 44px;
                height: 44px;
                background: white;
                border-radius: 0px 0px 0px 0px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 13px;
                color: #333333;
                line-height: 44px;
                text-align: center;
                cursor: pointer;
            }

            .nav-item-active {
                width: 44px;
                height: 44px;
                background: #17CC8A;
                border-radius: 0px 0px 0px 0px;
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 13px;
                color: #FFFFFF;
                line-height: 44px;
                text-align: center;
                cursor: pointer;
            }
        }

    }
}

.phone-scroll::-webkit-scrollbar {
    display: none;
}

.phone-masker {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.phone-maskerimg {
    width: 250px;
    height: 300px;
    background-image: url(../../../../assets/img_tanchuang@2x.png);
    background-repeat: no-repeat;
    background-size: contain;
}

.page-right {
    width: 1209px;

    .page-right-title {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #303033;
        line-height: 24px;
        margin-right: 16px;
    }

    .nav-title {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 14px;
        color: #303033;
        margin-top: 26px;
    }

    .nav-info {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #909099;
        margin-top: 18px;
    }
}

.right-title {
    width: 92px;
    height: 36px;
    background: #2d46ee;
    border-radius: 3px;
    font-size: 16px;
    margin-bottom: 40px;
    text-align: center;
    line-height: 36px;
    color: white;
}

.edit-title {
    font-size: 16px;
    color: #303033;
    font-weight: bold;
}

.line {
    width: 100%;
    height: 1px;
    background-color: #c0c0cc;
    margin: 18px auto;
}

.edit-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
}

.edit-name {
    font-size: 14px;
    font-weight: bold;
}

.addbox {
    width: 64px;
    height: 64px;
    background: #ffffff;
    border: 1px solid #c0c0cc;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    /* margin-left: 20px; */
}

.addicon {
    width: 24px;
    height: 24px;
}

.el-table th>.cell {
    font-size: 14px !important;
    text-align: left !important;
    /* padding-left: 30px !important; */
}

.el-table td {
    text-align: left !important;
}

.toselect {
    width: 100%;
    height: 32px;
    background: #e9ecfe;
    border-radius: 3px;
    line-height: 32px;
    padding: 0 10px;
    box-sizing: border-box;
    font-size: 14px;
    color: #2d46ee;
}

.el-dialog__header {
    border-bottom: none;
}

.el-dialog__body {
    padding-top: 18px;
}

.function-box {
    width: 100%;
    height: 557px;
    display: flex;
    color: #303033;
}

/deep/ .el-radio {
    color: #303033;
}

.function-left {
    width: 198px;
    height: 64px;
    background: #ffffff;
}

.function-right {
    flex: 1;
    height: 557px;
    background: #ffffff;
    border: 1px solid #e9ecfe;
    padding: 18px;
    box-sizing: border-box;
}

.function-item {
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    box-sizing: border-box;
    font-size: 16px;
}

.function-item-active {
    background-color: #e9ecfe;
    color: #2d46ee;
}

.select-box {
    width: 100%;
    height: 48px;
    background: #ffffff;
    display: flex;
    align-items: center;
    padding: 0 18px;
    box-sizing: border-box;
}

.select-box-active {
    background: #e9ecfe;
}

.search-ipt {
    flex: 1 !important;
    /* width: 518px !important; */
    height: 36px !important;
    background: #ffffff;
    border: 1px solid #c0c0cc;
    border-radius: 3px;
}

.categary-box {
    width: 678px;
    overflow-x: auto;
    white-space: nowrap;
    margin-top: 18px;
    padding-bottom: 18px;
}

.categary-item {
    padding: 8px 15px;
    background-color: #e9ecfe;
    font-size: 14px;
    margin-right: 18px;
    display: inline-block;
    cursor: pointer;
}

.categary-active {
    background-color: #2d46ee;
    color: white;
}

.select-goods {
    height: 72px;
}

.select-goods .el-radio {
    display: flex;
    align-items: center;
}

.goods-box {
    display: flex;
    align-items: center;
    font-size: 14px;
}

.goods-img {
    width: 48px;
    height: 48px;
    background: #d1d1d1;
    margin-right: 8px;
}

.goods-num {
    color: #606066;
    margin-top: 10px;
}

.pagibox {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 6px;
    right: 0;
}

.modul {
    padding: 12px;
    border-radius: 6px;
    color: white;
    background-color: #2d46ee;
    margin-right: 18px;
    min-width: 182px;
    height: 780px;
    overflow-y: auto;
    box-sizing: border-box;
}

.modul-item {
    width: 140px;
    height: 64px;
    background: #e9ecfe;
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding: 0 18px;
    margin-bottom: 8px;
    color: #2d46ee;
    cursor: pointer;
    box-sizing: border-box;
}

.addicon {
    width: 16px;
    height: 16px;
    margin-right: 4px;
}

.phone-search {
    width: 100%;
    height: 36px;
    background: #ffffff;
    border: 1px solid #f63c56;
    border-radius: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #cccccc;
    box-sizing: border-box;
}

.search-left {
    display: flex;
    align-items: center;
}

.search-icon {
    width: 18px;
    height: 18px;
    margin-right: 6px;
    margin-left: 10px;
}

.search-btn {
    // width: 58px;
    height: 32px;
    background: #f63c56;
    border-radius: 32px;
    color: white;
    // text-align: center;
    line-height: 32px;
    margin-right: 2px;
    padding: 0 16px;
}

.swiper-box {
    width: 100%;
    height: 124px;
    border-radius: 8px;
    background-color: #c0c0cc;
}

.swiper-img {
    width: 100%;
    height: auto;
    border-radius: 8px;
}

.mg-bttom {
    margin-bottom: 20px;
}

.title-box {
    display: flex;
    position: relative;
    color: #303033;
}

.main-title {
    font-size: 16px;
    font-weight: bold;
}

.secondary-title {
    font-size: 12px;
    color: #666666;
    position: absolute;
    right: 0;
    top: 2px;
}

.one-img {
    width: 100%;
    position: relative;

    .act-info {
        position: absolute;
        left: 8px;
        top: 12px;
    }

    .act-name {
        height: 24px;
        font-size: 20px;
        font-family: '黑体';
        font-weight: bold;
        font-style: italic;
        line-height: 1;
        color: #333333;
        overflow: hidden;
    }

    .act-intro {
        height: 14px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 17px;
        color: #333333;
        opacity: 1;

    }
}

.active-img {
    width: 100%;
    height: auto;
    border-radius: 8px;
}

.active-img1 {
    width: 100%;
    height: auto;
    border-radius: 8px;
    padding: 1px 1px;
    box-sizing: border-box;
}

.two-img {
    display: flex;
    justify-content: space-between;
}

.two-img-box {
    flex: 1;
    height: 84px;
}

.phone-goods {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.phone-goods-item {
    width: 49%;
    height: 291px;
    position: relative;
}

.goods-Item {
    width: 143px;
    height: 252px;
    position: relative;
    margin-right: 10px;

    .goods-Item-num {
        width: 72px;
        height: 17px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 17px;
        position: absolute;
        top: 3px;
        left: 5px;
        z-index: 10,
    }

    .goods-Item-status {
        width: 143px;
        height: 28px;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 100%);
        border-radius: 0px 0px 6px 6px;
        font-weight: 400;
        font-size: 13px;
        color: #FFFFFF;
        line-height: 28px;
        text-align: center;
        position: absolute;
        left: 0;
        top: 115px;
        z-index: 10,
    }
}

.phone-goods-img {
    width: 100%;
    height: 167px;
    margin-bottom: 8px;
}

.phone-goods-title {
    width: 100%;
    padding: 0 6px;
    box-sizing: border-box;
    font-size: 14px;
    color: #333333;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
}

.phone-goods-price {
    width: 100%;
    // position: absolute;
    // bottom: 4px;
    // left: 0;
    padding: 0 6px;
    box-sizing: border-box;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;

    .discount {
        min-width: 40px;
        height: 16px;
        background: linear-gradient(132deg, #2BDC9B 0%, #29B5E1 100%);
        border-radius: 2px;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 11px;
        color: #FFFFFF;
        line-height: 16px;
        text-align: center;
        margin-top: 4px;
    }

    .share {
        width: 30px;
        height: 14px;
        background: linear-gradient(91deg, #F63C56 0%, #FF006F 100%);
        border-radius: 2px;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 10px;
        color: #FFFFFF;
        line-height: 14px;
        text-align: center;
    }

    .sharePrice {
        width: 48px;
        height: 12px;
        background: #FFFFFF;
        border-radius: 2px;
        font-family: PingFang SC;
        font-weight: bold;
        font-size: 10px;
        color: #FF006E;
        line-height: 12px;
        text-align: center;
    }
}

.retail-price {
    font-size: 16px;
    color: #f63c56;
    font-weight: bold;
}

.market-price {
    font-size: 12px;
    color: #999999;
}

.two-num {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
}

.two-num-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #060606;
    margin-bottom: 20px;
}

.nav-img {
    width: 47px;
    height: 47px;
    margin-bottom: 8px;
}

/* .pr:hover .tool-bar{
      display: flex;
  } */
.tool-bar {
    height: 31px;
    background-color: rgba(0, 0, 0, 0.4);
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    padding: 0 8px;
    box-sizing: border-box;
    justify-content: flex-end;
    font-size: 14px;
    color: white;
    z-index: 11;
    /* display: none; */
}

.bar-item {
    display: flex;
    align-items: center;
    margin-left: 14px;
    cursor: pointer;
}

.bar-img {
    width: 18px;
    height: 18px;
}

.nopage {
    height: 100%;
    overflow-y: auto;
}

.active-tipb {
    position: relative;
}

.active-pic-tips {
    width: 250px;
    height: auto;
    background: #ffffff;
    box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    padding: 18px 10px;
    box-sizing: border-box;
}

.active-pic-title {
    font-size: 14px;
    color: #303033;
    margin-bottom: 8px;
}

.onegag {
    width: 230px;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    box-sizing: border-box;
    flex-direction: column;
    font-size: 12px;
    color: #909099;
    background-image: url(../../../../assets/img_pic333.png);
    background-repeat: no-repeat;
    background-size: cover;
    margin-bottom: 18px;
}

.twogag {
    width: 113px;
    background-image: url(../../../../assets/img_pic4@2x.png);
}

.el-popover {
    overflow: hidden;
    padding: 0;
}

.el-table [class*="el-table__row--level"] .el-table__expand-icon {
    display: none;
}

.bottom-box {
    width: 100%;
    height: 88px;
    border-top: 1px solid #ebebfa;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
}

.bottom-btn {
    width: 184px;
    height: 40px;
    background: #2d46ee;
    border-radius: 3px;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
}

/deep/ .el-message-box__status.el-icon-warning {
    color: #f63c56 !important;
}

/deep/ .el-message-box__status::before {
    color: #f63c56 !important;
}

.goods-type-button {
    width: 80px;
    height: 35px;
    font-size: 12px;
    color: #060606;
    text-align: center;
    line-height: 35px;
    border: 1px solid #d7d7d8;
    border-radius: 4px;
    box-sizing: border-box;
    margin-right: 30px;
    cursor: pointer;
    background-color: white;
}

.goods-type-active {
    background-color: #2d46ee;
    color: white;
}

///新后台
.festival-heng {
    width: 349px;
    height: 169px;
    border-radius: 16px;
    background-image: url(../../../../assets/indexIcon/bg_songli_s.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 15px auto 0;
    overflow: hidden;
}

.name-heng {
    height: 228px;
    background-image: url(../../../../assets/indexIcon/bg_mingyi.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.people-heng {
    height: 357px;
    background-image: url(../../../../assets/indexIcon/bg_renqun.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.festival-top {
    margin-top: 16px;
    margin-left: 8px;
    display: flex;
    align-items: flex-end;
    color: #ffffff;
}

.festival-title {
    font-size: 18px;
    font-weight: bold;
    margin-right: 6px;
}

.festival-small-title {
    font-size: 13px;
}

.festival-two {
    width: 349px;
    height: 118px;
    background: #FFFFFF;
    border-radius: 16px;
    margin-top: 10px;
    padding: 10px 8px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
}

.festival-two-item {
    width: 164px;
    height: 98px;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
}

.festival-two-img {
    width: 100%;
    height: 100%;
}

.festival-date {
    display: inline-block;
    padding: 4px 10px;
    background-color: #FF9D1D;
    color: white;
    border-radius: 8px 12px 12px 0;
    position: absolute;
    left: 0;
    top: 0;
    font-size: 12px;
}

.festival-btn {
    padding: 3px 13px;
    border: 1px solid #ffffff;
    border-radius: 12px;
    font-size: 13px;
    margin-right: 8px;
}

.name-scrollbox {
    width: 100%;
    height: 36px;
    border-radius: 16px 16px 0 0;
    background-color: #FDE9ED;
    position: relative;
    color: #EF1340;
    white-space: nowrap;
    padding-right: 5px;
    box-sizing: border-box;
}

.name-item {
    width: 94px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    font-size: 14px;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 0 10px;
    box-sizing: border-box;
}

.name-item-active {
    width: 94px;
    height: 40px;
    position: absolute;
    left: 0;
    top: -4px;
    background-image: url(../../../../assets/indexIcon/icon_mingyi_zuo.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    text-align: center;
    font-size: 15px;
    font-weight: bold;
    line-height: 40px;
}

.name-goods-box {
    width: 100%;
    height: 134px;
    background: #ffffff;
    border-radius: 0px 16px 16px 16px;
    display: flex;
    align-items: center;
    padding: 0 8px;
    box-sizing: border-box;
}

.name-goods-item {
    width: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    color: #EF1340;
}

.name-goods-img {
    width: 80px;
    height: 80px;
    border: 1px solid #F63C56;
    border-radius: 8px;
    margin-bottom: 6px;
}

.name-goods-price {
    text-align: center;
}

.people-box {
    width: 100%;
    height: 300px;
    margin-top: 13px;
    display: flex;
    justify-content: space-between;
}

.people-left {
    width: 106px;
}

.people-left-item {
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    margin-bottom: 24px;
    position: relative;
}

.people-left-item-active {
    width: 101px;
    height: 36px;
    font-size: 14px;
    color: #7700B9;
    font-weight: bold;
    background-image: url(../../../../assets/indexIcon/bg_sel.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    left: -4px;
    top: 0;
    line-height: 36px;
}

.people-right {
    width: 222px;
    height: 276px;
    margin-right: 9px;
    margin-top: 14px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.people-right-item {
    width: 107px;
    display: flex;
    flex-direction: column;
    font-size: 18px;
    color: #7700B9;
}

.people-right-img {
    width: 107px;
    height: 107px;
    border-radius: 8px;
    margin-bottom: 5px;
}

.newicon {
    width: 349px;
    height: 86px;
    display: block;
    margin: 0 auto;
}

.tag-item {
    padding: 2px 12px;
    font-size: 12px;
    color: #060606;
    border-radius: 12px;
    border: 1px solid #666666;
    margin-right: 14px;
    cursor: pointer;
}

.tag-item-active {
    background-color: #2d46ee;
    color: #ffffff;
    border: 1px solid #2d46ee;
}

.tag-disabled {
    color: #ffffff;
    background-color: #cccccc;
    border: 1px solid #cccccc;
    cursor: not-allowed;
}

.gift-tips {
    width: 32px;
    height: 16px;
    background: #F63C56;
    border-radius: 2px;
    margin-right: 4px;
    display: inline-block;
    font-size: 10px;
    color: #fff;
    text-align: center;
    line-height: 16px;
}
</style>